import { Component, OnInit,ElementRef, ViewChild,NgZone,ViewEncapsulation,OnChanges, OnDestroy,Input, Output,SimpleChanges,EventEmitter} from '@angular/core';
import {BrowserModule, DomSanitizer, Title} from '@angular/platform-browser'
import {Utils} from '../_util/utils';
import { ReportService } from '../inservice/report.service';
import { FrmService } from '../inservice/frm.service';
import { CookieService } from '../_services/cookie.service';
import { ChangeDetectorRef, AfterContentChecked} from '@angular/core';
import { InjectDirective } from '../_directive/inject.directive';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { ckeditorContentStyle } from 'src/config/ckeditorContentStyle';


declare var $: any;
@Component({
  selector: 'app-pdfdata',
  templateUrl: './pdfdata.component.html',
  styleUrls: ['./pdfdata.component.css']
})
export class PdfdataComponent implements OnInit {
	@Input() content:any;
	@Input() front:any;
	@Input() slot:any;
	@Input() id:any;
	@Input() rptInfo:any;
	@Input() pcaInfo:any;
   	@Input() appe:any;
	@Input() pdfgroup:any;
	@Input() xml:string;
	@Input() xmlN:string;
	
	@Input() rdata:string;
	@Input() toPrint:any;
	@Input() size:string;
	@Input() pop:string;
	//@Input() watermarker:any;
	@Output() spinToggle = new EventEmitter<string>(true);
	@Output() errorInfo = new EventEmitter<string>(true);
	@Output() okmsg = new EventEmitter<string>(true);
	@Output() delivermsg = new EventEmitter<any>(true);
	/*@Output() outText = new EventEmitter<string>(true);
	@Output() onExit = new EventEmitter<string>(true);
	@Output() selected = new EventEmitter<boolean>(true);
	@Output() rfSelected = new EventEmitter<string>();*/
	proId:string;
	logoInfo=[];
	userInfo:any;
	userId:string;
	r:string;
	selectedSlot:any;
	selectedRptType:string;
	selectedType="";
	//selectedCover={'COPIED_FROM_ID':null,'COVERPAGE_ID':null, 'COVERPAGE_TITLE':null};
	//selectedHeader={'COPIED_FROM_ID':null,'HEADER_ID':null, 'HF_TITLE':null};
	//selectedFooter={'COPIED_FROM_ID':null,'FOOTER_ID':null, 'HF_TITLE':null};
	//selectedTHeader={'COPIED_FROM_ID':null,'HEADER_ID':null, 'HF_TITLE':null};
	//selectedTFooter={'COPIED_FROM_ID':null,'FOOTER_ID':null, 'HF_TITLE':null};
	//selectedWatermarker={'WATERMARK_ID':null,'WATERMARK_DATA':null};
	//selectedIden="";
	public currSign='$';
	public bimageurl='';
	public selectPdi='96';
	public current:any;
	public reports=[];
	public covers=[];
	public covercopy=[];
	public headers=[];
	public headercopy=[];
	public footers=[];
	public footercopy=[];
	public theadercopy=[];
	public tfootercopy=[];
	public projectFiles=[];
	public currentDocIndex:string;
	//watermarkers=[];
	allSlots=[]
	public getSecData=0;
	public startP=0;
	public outDoc:string;
	private fileReader: FileReader;
	public pageMargin={'top':'0', 'bottom':"0", 'left':"25", 'right':"25"};
	public tocMargin={'top':'0', 'bottom':"0", 'left':"25", 'right':"25"};
	public portraitSize={'width':'816','height':'1056'};
	public landscapeSize={'width':'1056','height':'816'};
	public legalPortraitSize={'width':'816','height':'1344'};
	public legalLandscapeSize={'width':'1344','height':'816'};
	public ledgerPortraitSize={'width':'1056','height':'1632'};
	public ledgerLandscapeSize={'width':'1632','height':'1056'};
	public selectpage={'type':'portrait', 'size':{'width':'816','height':'1056'}};
	public immiWidth=['51','4','3','4','5','5','5','12','12'];
	public immiAlign=['Left','Right','Center','Right','Right','Right','Right','Right','Right'];
	public immiColAlign=['Center','Center','Center','Center','Center','Center','Center','Center','Center'];
	public immiHeaderWrap=[3,4,5];
	public outData:string;

	pdfs=[];
    ifPop='Y';  
	public otherTypes=["FIXED_SECTION", "PARA"];//['TABLE','MAP','LOCKED_CONTENT','COSTTABLE', 'PCATABLE','UNITTABLE'];
	//otherTypes=['TABLE','MAP','PHOTOS','LOCKED_CONTENT','COSTTABLE', 'PCATABLE','UNITTABLE','SEALS','SIGNS','PDFSEC', 'PISUMMARY','PITABLE','PCASUMMARY','COST'];
	public contents:any[];
	public frontpages=[];
	public appendices={'SECTION_SEQUENCE': "",'SECTION_TITLE': 'APPENDICES','SUB_SECTIONS':[]};
	public xmlcontent:string;
	public xmlName:string;
	public curReport:any;
	head1Space='1';
	head2Space='1';
	head3Space='1';
	lpagesize="legal-landscape";
	backgroundURL='';
	public sec3type1=[0,1,4,5]; //[0,1,4,5,6,7]; 
	public sec3type2=[2,3];
	public pcaSplittedTables:any[];
	@ViewChild(InjectDirective) injectComp: InjectDirective;
	@ViewChild("outContent") outContent: ElementRef;
	@ViewChild("frontContent") frontContent: ElementRef;
	@ViewChild("frmContent") frmContent: ElementRef;
  constructor(public sanitizer: DomSanitizer, public  reportService: ReportService, private zone: NgZone, private cookieService:CookieService,private router: Router,private cdref: ChangeDetectorRef, public frmService:FrmService,) { 
	this.userId = this.cookieService.getCookie("userID");
  }

  ngOnInit(): void {
	  //console.log(ckeditorContentStyle);
  }
  ngOnChanges(changes: SimpleChanges): void {
       if('content' in changes){
			if(this.content){
				this.contents=this.content;
				this.iniFrmdata();
			}		
		}
		if('front' in changes){
			if(this.front){
				this.frontpages=this.front;
			}		
		}
		if('pop' in changes){
			if(this.pop){
				this.ifPop=this.pop;
			}		
		}
		if('pcaInfo' in changes){
			if(this.pcaInfo){
				this.pcaOp=this.pcaInfo;
			}		
		}
		 if('rptInfo' in changes){
			if(this.rptInfo){
				this.curReport=this.rptInfo;
				this.getPara(this.rptInfo);
				//this.userId=this.rptInfo.USER_ID;	
				if(this.curReport.PCA_INDICATOR=='frm1105'||this.curReport.PCA_INDICATOR=='frm1104'||this.curReport.PHASE1_TYPE=='1103'){//this.backgroundURL=this.curReport.FRM_HEADER[0].HF_URL;
					this.backgroundURL="https://d2yly2kp48bv4r.cloudfront.net/Client-Files/1/5/HF/freddie_mac_header_QJMKDSYHUFWKM1CQDXJ5.html?Expires=2017076129&Signature=qGlEghuwlLc9Q~qGIKR0poq97d9zajPn4oTPkMSk9XKR~n3T2vgWIgD~VC2kKgIDNIfwl4aTvUjy4LFBYtvY9JxqgDj1LAKoWl2i~OJPxRBBk2tJCcC1KBE64pDfr00Nae9yuQvc6mIBvpoNee9647e4Xy2JSVT3Kk3LfzY4m~x4QQ0Pjqc7WmrPJqyxbyAO2OUnD081ovMitqCjuYQ~otbgcCadCfXe4eMW64kjc~NkpMUtE15wXj-1~Q0c0PlurXLRa955gSBOfFVRo1m3cpZqMgVAzCMkbbQFE-T8RSNVpxrCsTCrIY1tF64rPbczJTqB59TLQqbTtrPVFH9KkA__&Key-Pair-Id=K1A72OHWONZYJB"
				}	
				if(this.curReport.PCA_INDICATOR=='4099e'){
					this.adjustColWidth();
				}		
			}		
		}
		if('appe' in changes){
			if(this.appe){
				this.appendices=this.appe;
			}		
		}
		if('xml' in changes){
			if(this.xml){
				this.xmlcontent=this.xml;
			}		
		}
		if('xmlN' in changes){
			//if(this.xmlName){
				this.xmlName=this.xmlN;
			//}		
		}
		if('pdfgroup' in changes){
			if(this.pdfgroup){
				this.pdfs=this.pdfgroup;
			}		
		}
		if('rdata' in changes){
			if(this.rdata){
				this.r=this.rdata;
			}		
		}
		if('slot' in changes){
			if(this.slot){
				this.allSlots=this.slot;
			}		
		}
		/*if('watermarker' in changes){
			if(this.watermarker){
				this.selectedWatermarker=this.watermarker;
			}		
		}*/
		if('toPrint' in changes){
			if(this.curReport&&this.curReport['BODYINDENT_SAME_STITLE']=='Y'){
				this.checkIndent()
			}
			if(this.curReport&&this.curReport.PCA_INDICATOR=='4099e'){
				this.adjustColWidth();
			}
			if(this.curReport&&this.curReport.PCA_INDICATOR=='Y'){
				this.checksplit();
			}
			if(this.toPrint){
				//if(this.toPrint.type!='temp'){
				//	this.getPara();
				//}				
				if(this.toPrint.type){
					if(this.toPrint.type=='app'){
						this.preview(this.toPrint.type);
					}else{
						this.preview(this.toPrint.type);
					}
					
				}else{
					this.preview();
				}
			}		
		}
		if('size' in changes){
			if(this.size){
				this.lpagesize=this.size;
			}		
		}
		
		/*if('tmargin' in changes){
			if(this.tmargin){
				this.tocMargin=this.tmargin;
			}		
		}*/
			
	}
	async getPara(response){
		//let response=this.curReport;console.log(response)
		if(response.HEADING1_SPACING&&response.HEADING1_SPACING.length>0){
							this.head1Space=response.HEADING1_SPACING; 
						}
						if(response.HEADING2_SPACING&&response.HEADING2_SPACING.length>0){
							this.head2Space=response.HEADING2_SPACING
						}
						if(response.HEADING3_SPACING&&response.HEADING3_SPACING.length>0){
							this.head3Space=response.HEADING3_SPACING
						}
						
		
	}
	checksplit(){
		this.pcaSplittedTables=[];
		for(let sec of this.contents){
			if(sec.TYPE=="COST"){
				for(let sec1 of sec.SUB_SECTIONS){
					if(sec1['ZOOM']&&sec1.tableSize&&sec1.tableSize=="split"){
						if(sec1.pcaTableSetting&&sec1.pcaTableSetting.length>0){
							let oritable=JSON.parse(JSON.stringify(sec1.data))
							for(let sets of sec1.pcaTableSetting){
								if(sets.selected){
									let firstpartCols=oritable.cols.slice(0,9)
									let secondPartCols=oritable.cols.slice(8+sets.start, 8+sets.end+1);
									let tableCols=firstpartCols.concat(secondPartCols);
									if(sets.end==this.pcaOp.reserve){
										tableCols.push(JSON.parse(JSON.stringify(oritable.cols[oritable.cols.length-1])));
									}
									let tableRows=[];
									for(let row of oritable.rows){
										if(row.length==1){
											let newRow=JSON.parse(JSON.stringify(row))
											newRow[0].colspan=9+(sets.end-sets.start+1);
											if(sets.end==this.pcaOp.reserve){
												newRow[0].colspan=newRow[0].colspan+1;
											}
											tableRows.push(newRow);
										}else{
											let firstpartRow=row.slice(0,9)
											let secondPartRow=row.slice(8+sets.start, 8+sets.end+1);
											let wholeRow=firstpartRow.concat(secondPartRow);
											if(sets.end==this.pcaOp.reserve){
												let lastCell=JSON.parse(JSON.stringify(row[row.length-1]));
												wholeRow.push(lastCell);
											}
											tableRows.push(wholeRow);
										}										
									}
									let newtableData={'cols':tableCols, "rows":tableRows};
									this.pcaSplittedTables.push(newtableData)
								}
								
							}
							
						}
					}
				}
			}
		}
		//console.log(this.pcaSplittedTables)
	}
	async preview(type?, id?){
		if(type=='frm'||this.curReport.PCA_INDICATOR=='frm1105'){
			this.spinToggle.emit('start');
		 	this.iniFrmdata();
		}
		if(type=='frm'||this.curReport.PCA_INDICATOR=='frm1104'||this.curReport.PHASE1_TYPE=='1103'){
			this.spinToggle.emit('start');
		 	this.iniFrmdata();
		}
		if(this.curReport.PCA_INDICATOR=='4099e'){
			//this.adjustColWidth();
		}
		if((type=='app')||(type=='apponly')||(type=='xml')||(type=='frm')){
			await this.getUpdated();	
		}
		//setTimeout(() => {
			if((type=='app')||(type=='xml')||(type=='frm')){
				if(this.appendices&&this.appendices.SUB_SECTIONS.length>0){
					this.generatePdf(type);
				}else{
					Swal.fire({
						icon:'info',
						title: 'No Appendix Defined, Continue?',
						confirmButtonText: 'Continue',
						showLoaderOnConfirm: true,
						showCancelButton: true,
						backdrop:false,
						/*preConfirm: () => {
							if(type=='xml'||(type=='frm')){
								this.generatePdf(type);
							}else{
								this.generatePdf();
							}
							
						}*/
					}).then((response) => {
						if (response.isConfirmed) {
							if(type=='xml'||(type=='frm')){
								this.generatePdf(type);
							}else{
								this.generatePdf();
							}
						}else if(response.dismiss === Swal.DismissReason.cancel){
							this.spinToggle.emit('end');
							return
						}
					})
				}
			}else if(type=='apponly'){
				if(this.appendices&&this.appendices.SUB_SECTIONS.length>0){
					this.mergePdf('','','y');
				}else{
					this.spinToggle.emit('end');
					Swal.fire({
						html: ' <span style="color:red">No Appendix Defined!</span>',							
					})
					return
				}
				
			}else if(type=='draft'){console.log(id)
				this.generatePdf(type, id);
			}else if(type=='temp'){
				//console.log('template pdf')
				this.generateTempPdf();
			}else{
				this.generatePdf();
			}
			
		//},500);
		
	}
	async generateTempPdf(){
		this.spinToggle.emit('start');
		let profile='';
		let inputJson={"PROCEDURE":"getcompanyprofile","USER_ID":parseInt(this.userId),"TEMPLATE_ID":this.curReport.TEMPLATE_ID};console.log(inputJson);
		let grayscale='@media print {p span,li span {background-color: transparent!important;color: black!important; }}';
		let response=await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
			//console.log(response);
			if(response.RESPONSE_STATUS=="Y"){
				await this.getPara(response);
				await new Promise(f => setTimeout(f, 5000));
				let header=response.REPORT_BODY_HEAD;
				profile=atob(header); //console.log(profile)
				         //add the fixed a few part to profile 
				if(response.PRINT_BLACKWHITE=='Y'){
					let styleIndex=profile.indexOf('</style>');
					if(styleIndex>-1){
						profile=profile.slice(0, styleIndex) + grayscale +ckeditorContentStyle+ profile.slice(styleIndex);						
					}
				}
                profile = "<!DOCTYPE HTML><html><head>" + profile + "</head><body>";
			
				let allhtml=this.getPageData(profile, 'temp');
				this.pageMargin.top=response.REPORT_MARGIN_TOP;
				this.pageMargin.bottom=response.REPORT_MARGIN_BOTTOM;
				this.pageMargin.left=response.REPORT_MARGIN_LEFT;
				this.pageMargin.right=response.REPORT_MARGIN_RIGHT;
				this.tocMargin.top=response.TOC_MARGIN_TOP;
				this.tocMargin.bottom=response.TOC_MARGIN_BOTTOM;
				this.tocMargin.left=response.TOC_MARGIN_LEFT;
				this.tocMargin.right=response.TOC_MARGIN_RIGHT;	
				let coverUrl='';
				let headerUrl='';
				let footerUrl='';
				let theaderUrl='';
				let tfooterUrl='';
				let coverHtml ='';
				let headerHtml='';
				let footerHtml ='';
				let theaderHtml='';
				let tfooterHtml ='';
				if(response.COVERPAGE.COVERPAGE_DATA.length>0){
					//coverUrl=this.getUrl(this.covercopy, 'COVERPAGE_ID', 'COVERPAGE_HTML_URL', this.selectedCover.COVERPAGE_ID);//console.log(coverUrl);
					//coverHtml=this.getHtml(this.covercopy, 'COVERPAGE_ID', 'cover', this.selectedCover.COVERPAGE_ID);//console.log('coverhtml',coverHtml);//
					coverHtml=this.getHtml1(response.COVERPAGE, 'cover');
				}
				if(response.HEADER.HEADER_DATA.length>0){
					//headerUrl=this.getUrl(this.headercopy, 'HEADERFOOTER_ID', 'HF_URL', this.selectedHeader.HEADER_ID);//console.log(headerUrl);
					//headerHtml=this.getHtml(this.headercopy, 'HEADERFOOTER_ID', 'header', this.selectedHeader.HEADER_ID);//console.log(headerHtml);
					headerHtml=this.getHtml1(response.HEADER, 'header');
				}
				if(response.FOOTER.FOOTER_DATA.length>0){
					//footerUrl=this.getUrl(this.footercopy, 'HEADERFOOTER_ID', 'HF_URL', this.selectedFooter.FOOTER_ID);//console.log(footerUrl);
					//footerHtml=this.getHtml(this.footercopy, 'HEADERFOOTER_ID', 'footer', this.selectedFooter.FOOTER_ID);//console.log(footerHtml);
					footerHtml=this.getHtml1(response.FOOTER, 'footer');
				} 
				if(response.TOC_HEADER.HF_DATA&&response.TOC_HEADER.HF_DATA.length>0){
					//theaderUrl=this.getUrl(this.theadercopy, 'HEADERFOOTER_ID', 'HF_URL', this.selectedTHeader.HEADER_ID);//console.log(headerUrl);
					//theaderHtml=this.getHtml(this.theadercopy, 'HEADERFOOTER_ID', 'header', this.selectedTHeader.HEADER_ID);//console.log(headerHtml);
					theaderHtml=this.getHtml1(response.TOC_HEADER, 'theader');
				}
				if(response.TOC_FOOTER.HF_DATA&&response.TOC_FOOTER.HF_DATA.length>0){
					//tfooterUrl=this.getUrl(this.tfootercopy, 'HEADERFOOTER_ID', 'HF_URL', this.selectedTFooter.FOOTER_ID);//console.log(footerUrl);
					//tfooterHtml=this.getHtml(this.tfootercopy, 'HEADERFOOTER_ID', 'footer', this.selectedTFooter.FOOTER_ID);//console.log(footerHtml);
					tfooterHtml=this.getHtml1(response.TOC_FOOTER, 'tfooter');
				} 
     			let pagecontents=[];
				if(this.frontpages&&this.frontpages.length>0){
					for(let page of this.frontpages){
						let pagecontent={
							"type": page.pageSrc,
							"pdfurl": "",
							"base64": "",
							"sectionname": page.SECTION_TITLE,
							"searchstring": "",
							"headerbase64": "",
							"footerbase64": "",
							"header1base64": "",
							"footer1base64": "",
							"headerline": response.HEADER_LINE,
							"footerline": response.FOOTER_LINE,
						}
						if(page.pageSrc=='pdf'){
							pagecontent["pdfurl"]=page.pdf;
							pagecontent["searchstring"]=page.pdfName;
							let text='<p>'+page.pdfName+'<p>'
							pagecontent["base64"]=this.getFrontData(profile, text);					
						}else if(page.pageSrc=='report'){
							pagecontent["base64"]=this.getFrontData(profile, page.text, page.id);
						}else if(page.pageSrc=='letter_style'){
							pagecontent["base64"]=this.getFrontData(profile, page.text, page.id);
							if(page.header&&page.header.HEADERFOOTER_ID){
								pagecontent.headerbase64=this.updateUrl(page.header, 'theader');
								if(page.fHeader&&page.fHeader.HEADERFOOTER_ID){
									pagecontent.header1base64=this.updateUrl(page.fHeader, 'theader');
								}
							}
							if(page.footer&&page.footer.HEADERFOOTER_ID){
								pagecontent.footerbase64=this.updateUrl(page.footer,  'tfooter');
								if(page.fFooter&&page.fFooter.HEADERFOOTER_ID){
									pagecontent.footer1base64=this.updateUrl(page.fFooter,  'tfooter');
								}
							}
						}
						pagecontents.push(pagecontent);
					}
			
				}
				let middlepdfs=[];
				//console.log(this.contents)
				let mainpdfempty='N';
				if(this.contents.length==0){
					mainpdfempty="Y";
				}
				for(let sec of this.contents){
					if(sec.SUB_SECTIONS){
						for(let sec1 of sec.SUB_SECTIONS){					
							if(sec1.pageSrc=='pdf'&&sec1.pdf&&sec1.pdf.length>0){
								let seccontent={
								"pdfurl": sec1.pdf,
								"sectionname": sec1.SECTION_TITLE,
								"searchstring": sec1.id+sec1.pdfName,
								"showbookmark":"N",
								}																			
								middlepdfs.push(seccontent);console.log(seccontent)
							}
							if(sec1.SUB_SECTIONS){
								for(let sec2 of sec1.SUB_SECTIONS){
									if(sec2.pageSrc=='pdf'&&sec2.pdf&&sec2.pdf.length>0){
										let seccontent={
										"pdfurl": sec2.pdf,
										"sectionname": sec2.SECTION_TITLE,
										"searchstring": sec2.id+sec2.pdfName,
										"showbookmark":"N",
										}
										middlepdfs.push(seccontent);console.log(seccontent)														
									}	
								}
							}
						}
					}
				}		
		const pmargin = `${this.pageMargin.top} ${this.pageMargin.right} ${this.pageMargin.bottom} ${this.pageMargin.left}`;
		console.log(this.tocMargin.top)
		let tmargin=pmargin;
		if(this.tocMargin.top){
			tmargin = `${this.tocMargin.top} ${this.tocMargin.right} ${this.tocMargin.bottom} ${this.tocMargin.left}`;
		}
		this.reportService.generatePdf(allhtml, this.r,"newreport",'','Letter', this.selectpage.type, this.selectPdi, coverUrl, headerUrl,footerUrl,this.curReport.TOC_IND,coverHtml, [],headerHtml,footerHtml, response.HEADER_LINE, response.FOOTER_LINE, response.TOC_PAGENUMBER_FORMAT.toLowerCase(),response.TOC_STYLE.TOC_FILENAME,pmargin,pagecontents,this.curReport.TEMPLATE_TITLE,[],theaderHtml,tfooterHtml,tmargin, this.curReport.APPENDIX_NODATA_MESSAGE,mainpdfempty).subscribe((result) => {
		//this.reportService.generatePdf(allhtml, this.r,"newreport","",'Letter', this.selectpage.type, this.selectPdi, "", "", "", "N", "", [], "","", 'Y', 'Y', 'int','','',[],'',[]).subscribe((result) => {
   		
			console.log(result)
			if((result.RESPONSE_STATUS=="Y")&&(result.rurl.length>0)){
				this.spinToggle.emit('end');
				window.open(result.rurl, '_blank');
				//if(this.ifPop!='N'){
				//	this.popInfo(result.rurl, result.rtitle);
				//}
				//this.okmsg.emit(this.curReport.REPORT_ID);		
			}else{
				this.spinToggle.emit('end');
				this.errorInfo.emit(result['MESSAGE']);
				Swal.fire({
					html: ' <p style="color:red; text-align:left">'+result.MESSAGE+'</p>'	
				})
		
			}
 		 })	
		}else{
			this.spinToggle.emit('end');
				this.errorInfo.emit(response['MESSAGE']);
				Swal.fire({
					html: ' <p style="color:red; text-align:left">'+response.MESSAGE+'</p>'	
				})
		}
		
	}
	USDollar = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
		//trailingZeroDisplay: 'stripIfInteger',
	});
	USDollar1 = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
		maximumFractionDigits: 0, 
  		minimumFractionDigits: 0,
	});
	
	async generatePdf(type?, id?){
		this.spinToggle.emit('start');
		let profile='';
		let inputJson={"PROCEDURE":"getcompanyprofile","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID};//console.log(inputJson);
		//let grayscale='@media print{*{background-color:white !important;color:#000000 !important;}}';
		let grayscale='@media print {p span,li span {background-color: transparent!important;color: black!important; }}';
		let response= await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
			
			if(response.RESPONSE_STATUS=="Y"){
				await this.getPara(response);
				await new Promise(f => setTimeout(f, 5000));
				let appCover='';
				if(response.APPENDIX_COVERPAGE.APPENDIX_COVERPAGE_PATH){
					appCover=response.APPENDIX_COVERPAGE.APPENDIX_COVERPAGE_PATH;
				}
				let header=response.REPORT_BODY_HEAD;
				profile=atob(header); //console.log(profile)
				         //add the fixed a few part to profile 
				if(response.PRINT_BLACKWHITE=='Y'){
					let styleIndex=profile.indexOf('</style>');
					if(styleIndex>-1){
						profile=profile.slice(0, styleIndex) + grayscale + ckeditorContentStyle+ profile.slice(styleIndex);						
					}
				}
                profile = "<!DOCTYPE HTML><html><head>" + profile + "</head><body>";
			
				let allhtml=this.getPageData(profile);
				this.pageMargin.top=response.REPORT_MARGIN_TOP;
				this.pageMargin.bottom=response.REPORT_MARGIN_BOTTOM;
				this.pageMargin.left=response.REPORT_MARGIN_LEFT;
				this.pageMargin.right=response.REPORT_MARGIN_RIGHT;	
				this.tocMargin.top=response.TOC_MARGIN_TOP;
				this.tocMargin.bottom=response.TOC_MARGIN_BOTTOM;
				this.tocMargin.left=response.TOC_MARGIN_LEFT;
				this.tocMargin.right=response.TOC_MARGIN_RIGHT;	
				this.lpagesize=response.PCA_PAGE_SETUP;
				let frmJson:any;
				if(this.curReport?.PCA_INDICATOR=='frm1105'||this.curReport?.PCA_INDICATOR=='frm1104'||this.curReport.PHASE1_TYPE=='1103'){
					frmJson=this.getFrmData(response); 
				}
				
		/*let html='';
		html=profile;
		console.log(html)
		html += `<div class="page-after">`;
		let hi=(1056-parseInt(this.pageMargin.top)-parseInt(this.pageMargin.bottom)).toString()+'px';
		let top=(parseInt(this.pageMargin.top)).toString(); console.log(top);
		let bottom=(parseInt(this.pageMargin.bottom)).toString();
		html +=`<div style="height:`+hi+`; background: url('`+this.bimageurl+`'); background-repeat: no-repeat; background-size: cover;">`
		*/
		let coverUrl='';
		let headerUrl='';
		let footerUrl='';
		let theaderUrl='';
		let tfooterUrl='';
		let coverHtml ='';
		let headerHtml='';
		let footerHtml ='';
		let theaderHtml='';
		let tfooterHtml ='';
		/*if(this.selectedCover.COVERPAGE_ID){
			//coverUrl=this.getUrl(this.covercopy, 'COVERPAGE_ID', 'COVERPAGE_HTML_URL', this.selectedCover.COVERPAGE_ID);//console.log(coverUrl);
			coverHtml=this.getHtml(this.covercopy, 'COVERPAGE_ID', 'cover', this.selectedCover.COVERPAGE_ID);//console.log('coverhtml',coverHtml);//
			
		}
		if(this.selectedHeader.HEADER_ID){
			//headerUrl=this.getUrl(this.headercopy, 'HEADERFOOTER_ID', 'HF_URL', this.selectedHeader.HEADER_ID);//console.log(headerUrl);
			//headerHtml=this.getHtml(this.headercopy, 'HEADERFOOTER_ID', 'header', this.selectedHeader.HEADER_ID);//console.log(headerHtml);
		}
		if(this.selectedFooter.FOOTER_ID){
			//footerUrl=this.getUrl(this.footercopy, 'HEADERFOOTER_ID', 'HF_URL', this.selectedFooter.FOOTER_ID);//console.log(footerUrl);
			//footerHtml=this.getHtml(this.footercopy, 'HEADERFOOTER_ID', 'footer', this.selectedFooter.FOOTER_ID);//console.log(footerHtml);
		} 
		if(this.selectedTHeader.HEADER_ID){
			//theaderUrl=this.getUrl(this.theadercopy, 'HEADERFOOTER_ID', 'HF_URL', this.selectedTHeader.HEADER_ID);//console.log(headerUrl);
			//theaderHtml=this.getHtml(this.theadercopy, 'HEADERFOOTER_ID', 'header', this.selectedTHeader.HEADER_ID);//console.log(headerHtml);
		}
		if(this.selectedTFooter.FOOTER_ID){
			//tfooterUrl=this.getUrl(this.tfootercopy, 'HEADERFOOTER_ID', 'HF_URL', this.selectedTFooter.FOOTER_ID);//console.log(footerUrl);
			//tfooterHtml=this.getHtml(this.tfootercopy, 'HEADERFOOTER_ID', 'footer', this.selectedTFooter.FOOTER_ID);//console.log(footerHtml);
		}*/
		if(response.COVERPAGE.COVERPAGE_DATA.length>0){
			//coverUrl=this.getUrl(this.covercopy, 'COVERPAGE_ID', 'COVERPAGE_HTML_URL', this.selectedCover.COVERPAGE_ID);//console.log(coverUrl);
			//coverHtml=this.getHtml(this.covercopy, 'COVERPAGE_ID', 'cover', this.selectedCover.COVERPAGE_ID);//console.log('coverhtml',coverHtml);//
			coverHtml=this.getHtml1(response.COVERPAGE, 'cover');
		}
		if(response.HEADER.HEADER_DATA.length>0){
			//headerUrl=this.getUrl(this.headercopy, 'HEADERFOOTER_ID', 'HF_URL', this.selectedHeader.HEADER_ID);//console.log(headerUrl);
			//headerHtml=this.getHtml(this.headercopy, 'HEADERFOOTER_ID', 'header', this.selectedHeader.HEADER_ID);//console.log(headerHtml);
			headerHtml=this.getHtml1(response.HEADER, 'header');
		}
		if(response.FOOTER.FOOTER_DATA.length>0){
			//footerUrl=this.getUrl(this.footercopy, 'HEADERFOOTER_ID', 'HF_URL', this.selectedFooter.FOOTER_ID);//console.log(footerUrl);
			//footerHtml=this.getHtml(this.footercopy, 'HEADERFOOTER_ID', 'footer', this.selectedFooter.FOOTER_ID);//console.log(footerHtml);
			footerHtml=this.getHtml1(response.FOOTER, 'footer');
		} 
		if(response.TOC_HEADER.HF_DATA&&response.TOC_HEADER.HF_DATA.length>0){
			//theaderUrl=this.getUrl(this.theadercopy, 'HEADERFOOTER_ID', 'HF_URL', this.selectedTHeader.HEADER_ID);//console.log(headerUrl);
			//theaderHtml=this.getHtml(this.theadercopy, 'HEADERFOOTER_ID', 'header', this.selectedTHeader.HEADER_ID);//console.log(headerHtml);
			theaderHtml=this.getHtml1(response.TOC_HEADER, 'theader');
		}
		if(response.TOC_FOOTER.HF_DATA&&response.TOC_FOOTER.HF_DATA.length>0){
			//tfooterUrl=this.getUrl(this.tfootercopy, 'HEADERFOOTER_ID', 'HF_URL', this.selectedTFooter.FOOTER_ID);//console.log(footerUrl);
			//tfooterHtml=this.getHtml(this.tfootercopy, 'HEADERFOOTER_ID', 'footer', this.selectedTFooter.FOOTER_ID);//console.log(footerHtml);
			tfooterHtml=this.getHtml1(response.TOC_FOOTER, 'tfooter');
		}  
     	/*
		if(response.COVERPAGE&&response.COVERPAGE.COVERPAGE_DATA.length>0){
          coverHtml = this.updateHFDate(response.COVERPAGE.COVERPAGE_DATA, 'cover');
     	}
		if(response.HEADER&&response.HEADER.HEADER_DATA.length>0){
          headerHtml = this.updateHFDate(response.HEADER.HEADER_DATA, 'header');
     	}
     	if(response.FOOTER&&response.FOOTER.FOOTER_DATA.length>0){
       	 footerHtml = this.updateHFDate(response.FOOTER.FOOTER_DATA, 'footer');
     	}*/
		let pagecontents=[];
		if(this.frontpages&&this.frontpages.length>0){
			for(let page of this.frontpages){
				let pagecontent={
					"type": page.pageSrc,
					"pdfurl": "",
					"base64": "",
					"sectionname": page.SECTION_TITLE,
					"searchstring": "",
					"headerbase64": "",
					"footerbase64": "",
					"header1base64": "",
					"footer1base64": "",
					"headerline": response.HEADER_LINE,
					"footerline": response.FOOTER_LINE,
				}
				if(page.pageSrc=='pdf'){
					pagecontent["pdfurl"]=page.pdf;
					pagecontent["searchstring"]=page.pdfName;
					let text='<p>'+page.pdfName+'<p>'
					pagecontent["base64"]=this.getFrontData(profile, text);					
				}else if(page.pageSrc=='report'){
					pagecontent["base64"]=this.getFrontData(profile, page.text, page.id);
				}else if(page.pageSrc=='letter_style'){
					pagecontent["base64"]=this.getFrontData(profile, page.text, page.id);
					if(page.header&&page.header.HEADERFOOTER_ID){
						pagecontent.headerbase64=this.updateUrl(page.header, 'theader');
						if(page.fHeader&&page.fHeader.HEADERFOOTER_ID){
							pagecontent.header1base64=this.updateUrl(page.fHeader, 'theader');
						}
					}
					if(page.footer&&page.footer.HEADERFOOTER_ID){
						pagecontent.footerbase64=this.updateUrl(page.footer,  'tfooter');
						if(page.fFooter&&page.fFooter.HEADERFOOTER_ID){
							pagecontent.footer1base64=this.updateUrl(page.fFooter,  'tfooter');
						}
					}
				}
				pagecontents.push(pagecontent);
			}
			
		}
		let middlepdfs=[];
		//console.log(this.contents)
		let mainpdfempty='N';
		if(this.contents.length==0){
			mainpdfempty="Y";
		}
		for(let sec of this.contents){
			if(sec.SUB_SECTIONS){
				for(let sec1 of sec.SUB_SECTIONS){
				
				if(sec1.pageSrc=='pdf'&&sec1.pdf&&sec1.pdf.length>0){
					let seccontent={
					"pdfurl": sec1.pdf,
					"sectionname": sec1.SECTION_TITLE,
					"searchstring": sec1.id+sec1.pdfName,
					"showbookmark":"N",
					}																			
					middlepdfs.push(seccontent);console.log(seccontent)
				}
				
			
			
			
				if(sec1.SUB_SECTIONS){
					for(let sec2 of sec1.SUB_SECTIONS){
				
				if(sec2.pageSrc=='pdf'&&sec2.pdf&&sec2.pdf.length>0){
					let seccontent={
					"pdfurl": sec2.pdf,
					"sectionname": sec2.SECTION_TITLE,
					"searchstring": sec2.id+sec2.pdfName,
					"showbookmark":"N",
					}
					middlepdfs.push(seccontent);console.log(seccontent)														
				}				
			
		
		
		}
		}
		}
			}
			}
	
		let pdfFname='';
		if(this.curReport.PDF_FILE_NAME.length>0){
			pdfFname=JSON.parse(this.curReport.PDF_FILE_NAME).name.replace(/[^a-zA-Z0-9]/g, "_");
		}
		
		const pmargin = `${this.pageMargin.top} ${this.pageMargin.right} ${this.pageMargin.bottom} ${this.pageMargin.left}`;
		let tmargin=pmargin;
		if(this.tocMargin.top){
			tmargin = `${this.tocMargin.top} ${this.tocMargin.right} ${this.tocMargin.bottom} ${this.tocMargin.left}`;
		}
		if(type&&(type=='app'||(type=='xml'&&this.appendices&&this.appendices.SUB_SECTIONS.length>0)||type=='frm')){
				let appData=this.getAppData();console.log(appData)
				/*if(appData.length==0){
					//this.spinToggle.emit('end');
					
				Swal.fire({
					html: ' <span style="color:red">No Appendix Data!</span>',					
				})
				
				//return
			}*/
			let result:any;
			if(this.curReport.PCA_INDICATOR=='frm1105'||this.curReport.PCA_INDICATOR=='frm1104'||this.curReport.PHASE1_TYPE=='1103'){
				result=await this.reportService.generateFRMPdfwithApp(appCover,'Y','Y',response.APPENDIX_TITLEPAGE_IND,response.APPENDIX_TITLEPAGE_FILE_IND, appData, allhtml, this.r,"newreport","",'Letter', this.selectpage.type, this.selectPdi, coverUrl, headerUrl,footerUrl,this.curReport.TOC_IND,coverHtml, [],headerHtml,footerHtml, response.HEADER_LINE, response.FOOTER_LINE, response.TOC_PAGENUMBER_FORMAT.toLowerCase(),response.TOC_STYLE.TOC_FILENAME, pmargin, pagecontents, pdfFname,middlepdfs,theaderHtml,tfooterHtml,tmargin, this.curReport.APPENDIX_NODATA_MESSAGE, frmJson).toPromise();
			}else{
				result=await this.reportService.generatePdfwithApp(appCover,'Y','Y',response.APPENDIX_TITLEPAGE_IND,response.APPENDIX_TITLEPAGE_FILE_IND, appData, allhtml, this.r,"newreport","",'Letter', this.selectpage.type, this.selectPdi, coverUrl, headerUrl,footerUrl,this.curReport.TOC_IND,coverHtml, [],headerHtml,footerHtml, response.HEADER_LINE, response.FOOTER_LINE, response.TOC_PAGENUMBER_FORMAT.toLowerCase(),response.TOC_STYLE.TOC_FILENAME, pmargin, pagecontents, pdfFname,middlepdfs,theaderHtml,tfooterHtml,tmargin, this.curReport.APPENDIX_NODATA_MESSAGE,mainpdfempty).toPromise();
			}
			console.log(result);
				//this.spinToggle.emit('end');
				let xmlreturn:any
				if((result.status=="Y")&&(result.rurl.length>0)){
					if(this.curReport.STATUS!='Final'&&response.WATERMARK.WATERMARK_DATA.length>0){//(type&&type=='draft'){
						this.mergeDraft(pdfFname, result.rurl, response.WATERMARK.WATERMARK_DATA, type);
					}else{
						//window.open(result.rurl, '_blank');	
						if(type=='xml'){
							xmlreturn=await this.toxml(result.rurl);
							if(!xmlreturn) return
						}
						if(type=='frm'){
							xmlreturn=await this.toFrm(result.rurl);
							if(!xmlreturn) return
						}
						let inputJson7= {"PROCEDURE":"updatereport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"REPORT_URL":result.rurl};
						this.reportService.univeralService(JSON.stringify(inputJson7)).subscribe(data => {
							if (data.RESPONSE_STATUS=='N') {
								this.errorInfo.emit(data['MESSAGE']);
								let deliverinfo={'id':this.curReport.REPORT_ID, "url":data['MESSAGE'], 'title':result.rtitle, 'status':data.RESPONSE_STATUS};
								this.delivermsg.emit(deliverinfo);
								this.throwError(data)
								return											
							}else{
								this.okmsg.emit(this.curReport.REPORT_ID);
								let deliverinfo={'id':this.curReport.REPORT_ID, "url":result.rurl, 'title':result.rtitle, 'status':result.RESPONSE_STATUS}
								this.delivermsg.emit(deliverinfo);
								if(this.ifPop!='N'){
									if(type=='xml'){
										this.popInfo(xmlreturn.ZIP_FILE, xmlreturn.REPORT_TITLE, 'xml');
									}else if(type=='frm'){
										this.popInfo(xmlreturn.ZIP_FILE, xmlreturn.REPORT_TITLE, 'xml');
									}else{
										this.popInfo(result.rurl, result.rtitle);
									}
																
								}
							}							
							this.spinToggle.emit('end');
						
						//this.okmsg.emit(this.curReport.REPORT_ID);
					})
					}
										
				}else{
					this.spinToggle.emit('end');	
					let msg=result['MESSAGE'];
					this.errorInfo.emit(msg);
					let deliverinfo={'id':this.curReport.REPORT_ID, "url":result['MESSAGE'], 'title':result.rtitle, 'status':result.RESPONSE_STATUS}
					this.delivermsg.emit(deliverinfo);
					Swal.fire({
						html: ' <p style="color:red; text-align:left">'+msg+'</p>'							
					})
					
				}
			//})
		}else{//console.log(type)
			let result:any;
				if(this.curReport.PCA_INDICATOR=='frm1105'||this.curReport.PCA_INDICATOR=='frm1104'||this.curReport.PHASE1_TYPE=='1103'){
					result=await this.reportService.generateFRMPdf(allhtml, this.r,"newreport","",'Letter', this.selectpage.type, this.selectPdi, coverUrl, headerUrl,footerUrl,this.curReport.TOC_IND,coverHtml, [],headerHtml,footerHtml, response.HEADER_LINE, response.FOOTER_LINE, response.TOC_PAGENUMBER_FORMAT.toLowerCase(),response.TOC_STYLE.TOC_FILENAME,pmargin,pagecontents,pdfFname,middlepdfs,theaderHtml,tfooterHtml,tmargin, this.curReport.APPENDIX_NODATA_MESSAGE, frmJson).toPromise();
				}else{
					result=await this.reportService.generatePdf(allhtml, this.r,"newreport","",'Letter', this.selectpage.type, this.selectPdi, coverUrl, headerUrl,footerUrl,this.curReport.TOC_IND,coverHtml, [],headerHtml,footerHtml, response.HEADER_LINE, response.FOOTER_LINE, response.TOC_PAGENUMBER_FORMAT.toLowerCase(),response.TOC_STYLE.TOC_FILENAME,pmargin,pagecontents,pdfFname,middlepdfs,theaderHtml,tfooterHtml,tmargin, this.curReport.APPENDIX_NODATA_MESSAGE,mainpdfempty).toPromise();//subscribe((result) => {
				//console.log(result)
				}
				//console.log(result)
				let xmlreturn:any;
		if((result.status=="Y")&&(result.rurl.length>0)){
			if(this.curReport.STATUS!='Final'&&response.WATERMARK.WATERMARK_DATA.length>0){//(type&&type=='draft'){
				this.mergeDraft(pdfFname, result.rurl, response.WATERMARK.WATERMARK_DATA, type);
			}else{
				if(type=='xml'){
					xmlreturn=await this.toxml(result.rurl);
					if(!xmlreturn) return
				}
				//window.open(result.rurl, '_blank');
					
				let inputJson= {"PROCEDURE":"updatereport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"REPORT_URL":result.rurl};
					this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
						this.spinToggle.emit('end');
						if(data.RESPONSE_STATUS!='Y'){
							this.errorInfo.emit(data['MESSAGE']);
							let deliverinfo={'id':this.curReport.REPORT_ID, "url":data['MESSAGE'], 'title':result.rtitle, 'status':data.RESPONSE_STATUS}
							this.delivermsg.emit(deliverinfo);
							this.throwError(data)
							return
								
						}else{
							if(this.ifPop!='N'){
								if(type=='xml'){
									this.popInfo(xmlreturn.ZIP_FILE, xmlreturn.REPORT_TITLE, 'xml');
								}else{
									this.popInfo(result.rurl, result.rtitle);
								}
						
							}
							this.okmsg.emit(this.curReport.REPORT_ID);
							let deliverinfo={'id':this.curReport.REPORT_ID, "url":result.rurl, 'title':result.rtitle, 'status':result.RESPONSE_STATUS}
							this.delivermsg.emit(deliverinfo);
							
						}									
						
			
					})
					
				
			}
		}else{
			this.spinToggle.emit('end');
			this.errorInfo.emit(result['MESSAGE']);
			let deliverinfo={'id':this.curReport.REPORT_ID, "url":result['MESSAGE'], 'title':result.rtitle, 'status':result.RESPONSE_STATUS}
			this.delivermsg.emit(deliverinfo);
			Swal.fire({
				html: ' <p style="color:red; text-align:left">'+result.MESSAGE+'</p>'	
			})
			
		}
	 // })	  
	}
	}else{
		this.spinToggle.emit('end');
		this.errorInfo.emit(response['MESSAGE']);
		let deliverinfo={'id':this.curReport.REPORT_ID, "url":response['MESSAGE'], 'title':response.rtitle, 'status':response.RESPONSE_STATUS}
		this.delivermsg.emit(deliverinfo);
		this.throwError(response);
		
			}
			
		
		}
	async mergeDraft(rtitle, rurl, wartermark, type?){
		//let index= this.watermarkers.findIndex(watermarker=>watermarker.WATERMARK_ID==id);
		//let data=JSON.parse(this.watermarkers[index].WM_DATA); 				
		let data=JSON.parse(wartermark); 
		let pdfFname="";
			if(this.curReport.PDF_FILE_NAME.length>0){
				pdfFname=JSON.parse(this.curReport.PDF_FILE_NAME).name.replace(/[^a-zA-Z0-9]/g, "_");
			}		
			let inputJson=	{
	    		"r": this.r,
	    		"position":data.position,
	   			"argb":this.rgba2hex(data.color),
	   			"text":data.text,
	   		 	"pdfurl": rurl,
				"fontsize":data.fontsize,
	   			"fontname":data.fontname,
				"inputfilename":rtitle+'.pdf', 
				"finalpdfname":pdfFname
			}		
			console.log(inputJson)	
			let result=await this.reportService.mergeDraft(inputJson).toPromise();//subscribe(result=>{		
				//console.log(result)		
				let xmlreturn:any;					
				if(result.RESPONSE_STATUS=='N'){
					this.spinToggle.emit('end');
					this.errorInfo.emit(result['MESSAGE']);
					let deliverinfo={'id':this.curReport.REPORT_ID, "url":result['MESSAGE'], 'title':result.rtitle, 'status':result.RESPONSE_STATUS}
					this.delivermsg.emit(deliverinfo);
					Swal.fire({
							html: ' <p style="color:red; text-align:left">'+result.MESSAGE+'</p>'							
						})						
					return
				}				
				//window.open(result.rurl, '_blank');
				if(type=='xml'){
					xmlreturn=await this.toxml(result.rurl, 'draft');
					if(!xmlreturn) return	
				}
				if(type=='frm'){
					xmlreturn=await this.toFrm(result.rurl, 'draft');
					if(!xmlreturn) return
				}
				let inputJson8= {"PROCEDURE":"updatereport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"REPORT_URL":result.rurl};
				this.reportService.univeralService(JSON.stringify(inputJson8)).subscribe(info => {
					this.spinToggle.emit('end');
					if (info.RESPONSE_STATUS=='N') {
						this.errorInfo.emit(info['MESSAGE']);
						let deliverinfo={'id':this.curReport.REPORT_ID, "url":info['MESSAGE'], 'title':result.rtitle, 'status':info.RESPONSE_STATUS}
						this.delivermsg.emit(deliverinfo);
						this.throwError(info)
						return											
					}else{
						if(this.ifPop!='N'){
							if(type=='xml'){
								this.popInfo(xmlreturn.ZIP_FILE, xmlreturn.REPORT_TITLE, 'xml');
							}else if(type=='frm'){
								this.popInfo(xmlreturn.ZIP_FILE, xmlreturn.REPORT_TITLE, 'xml');
							}else{
								this.popInfo(result.rurl, rtitle);
							}
						}
						this.okmsg.emit(this.curReport.REPORT_ID);
						let deliverinfo={'id':this.curReport.REPORT_ID, "url":result.rurl, 'title':result.rtitle, 'status':info.RESPONSE_STATUS}
						this.delivermsg.emit(deliverinfo);
					}								
				})
				
			//})
		
	}
	getFrontData(profileheader, frontdata, id?){
		let html='';
		html=profileheader;
		
		html += `<div class="page-after">`;
		/*let hi=(1056-parseInt(this.pageMargin.top)-parseInt(this.pageMargin.bottom)).toString()+'px';
		let top=(parseInt(this.pageMargin.top)).toString(); 
		let bottom=(parseInt(this.pageMargin.bottom)).toString();
		html +=`<div style="height:`+hi+`; margin:0; background: url('`+this.bimageurl+`');background-repeat: no-repeat;background-size: cover;">`*/
		html +=`<div style="background:url('`+this.bimageurl+`'); background-repeat:no-repeat; background-size:cover;">`;
		//html +=`<div style="height:`+hi+`; margin:0; padding:`+top+'px '+this.pageMargin.right+'px '+this.pageMargin.bottom+'px '+this.pageMargin.left+'px'+`; background: url('`+this.bimageurl+`');background-repeat: no-repeat;background-size: cover; margin:0">`
		
		if(id){
			frontdata=$('#'+id+'front')[0].outerHTML;// console.log(frontdata)
		}		
		html+=frontdata; 
	    html += `</div></div>`;
		html += this.reportService.tagEnd;
		return btoa(encodeURIComponent(html).replace(/%([0-9A-F]{2})/g, function (match, p1) {
			return String.fromCharCode(parseInt('0x' + p1, 16));
		}));
	}
	getPageData(profileheader, type?){
		let html='';
		html=profileheader;
		
		html += `<div class="page-after">`;
		html +=`<div style="background:url('`+this.bimageurl+`'); background-repeat:no-repeat; background-size:cover;">`;
		html+=this.outContent.nativeElement.innerHTML.replaceAll('legal-landscape', this.lpagesize); //console.log(this.outContent.nativeElement.innerHTML)
		if(type){
			html=this.replaceErisTable(html, type); 
		}else{
			html=this.replaceErisTable(html); 
		}
		
	    html += `</div></div>`;
		html += this.reportService.tagEnd;//console.log(html)
		return btoa(encodeURIComponent(html).replace(/%([0-9A-F]{2})/g, function (match, p1) {
			return String.fromCharCode(parseInt('0x' + p1, 16));
		}));
	}
	
	getFrmData(profile){
		let frmJson:any;
		if(this.curReport.PCA_INDICATOR=='frm1105'){
			frmJson= {
				"filename": this.frmSec.SECTION_TITLE,
				"frmfooterbase64": profile.FRM_FOOTER.HF_DATA?this.updateUrl(profile.FRM_FOOTER,  'ffooter'):'',
				"frmheaderbase64": "",
				"frmhtmlbody64": this.getFrmHtml(),
				"frmmiddlepdf": {
					"pdfurl": "",
					"sectionname": this.frmSec.SECTION_TITLE,
					"searchstring": this.frmSec.searchstring,
					"showbookmark": "N"			
				}
			}
		}else if(this.curReport.PCA_INDICATOR=='frm1104'||this.curReport.PHASE1_TYPE=='1103'){			
			frmJson= {
				"filename": 'Freddie Mac',
				"frmfooterbase64": profile.FRM_FOOTER.HF_DATA?this.updateUrl(profile.FRM_FOOTER,  'ffooter'):'',
				"frmheaderbase64": "",
				"frmhtmlbody64": this.getFrmHtml(),
				"frmmiddlepdf": {
					"pdfurl": "",
					"sectionname": 'Freddie Mac',
					"searchstring": this.frmsearchstring,
					"showbookmark": "N"			
				}
			}
		}
		
		return frmJson	
	}
	getFrmHtml(){
		let html=this.frmService.pdfHead;
		html+=this.frmContent.nativeElement.innerHTML;
		html+='</main></body></html>';//console.log(html)
		return btoa(encodeURIComponent(html).replace(/%([0-9A-F]{2})/g, function (match, p1) {
			return String.fromCharCode(parseInt('0x' + p1, 16));
		}));
	}
	getAppData(){
		let mainPdf={
					"doctitle":'' ,
					"filepath": "",
					"fileurl": '',
				}
			let pdffiles=[];
			for(let sec of this.appendices.SUB_SECTIONS){
				if(sec.omit){
					continue
				}
				if(sec.nodata){
					let item={"parenttitle": sec.SECTION_TITLE,"files": []};
					pdffiles.push(item);
					continue
				}
				if(sec.app){
						let item={"parenttitle": sec.SECTION_TITLE,"files": []};
						for(let pdf of sec.app){
							if(pdf.selectedfile){
								if(pdf.url&&pdf.url.length>0){
									let title=pdf.name;
									if(pdf.text) title=pdf.text;
									let data={
										"doctitle": title,
										"filepath": "",
										"fileurl": pdf.url,
										"numberpages":0
									}
									item.files.push(data);
								}else if(pdf['RESUME_URL']&&pdf['RESUME_URL'].length>0){
									let title=pdf.RESUME_TITLE;									
									let data={
										"doctitle": title,
										"filepath": "",
										"fileurl": pdf.RESUME_URL,
										"numberpages":0
									}
									item.files.push(data);

								}								
							}							
						};							
						pdffiles.push(item);
				}else{
					let item={"parenttitle": sec.SECTION_TITLE,"files": []};
					pdffiles.push(item);
				}				
			
			}
			return pdffiles			
		
	}
	mergePdf(rtitle, rurl, type){
		this.spinToggle.emit('start');
		if(this.appendices&&this.appendices.SUB_SECTIONS.length>0){
		let inputJson1={"PROCEDURE":"getcompanyprofile","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID}
			
		this.reportService.univeralService(JSON.stringify(inputJson1)).subscribe(response=>{
			
			if(response.RESPONSE_STATUS=="Y"){
				let appCover='';
				if(response.APPENDIX_COVERPAGE.APPENDIX_COVERPAGE_PATH){
					appCover=response.APPENDIX_COVERPAGE.APPENDIX_COVERPAGE_PATH;
				}
				
			let mainPdf={
					"doctitle":'' ,
					"filepath": "",
					"fileurl": '',
				}
			let pdffiles=[];
			if(type=='n'){
				mainPdf.doctitle=rtitle;
				mainPdf.fileurl	=rurl;		
			}//else if(type=='y'){
				//this.spinToggle.emit('end');
			//}
			for(let sec of this.appendices.SUB_SECTIONS){
				if(sec.omit){
					continue
				}
				if(sec.nodata){
					let item={"parenttitle": sec.SECTION_TITLE,"files": []};
					pdffiles.push(item);
					continue
				}
				if(sec.app){
						let item={"parenttitle": sec.SECTION_TITLE,"files": []};
						for(let pdf of sec.app){
							if(pdf.selectedfile){
								if(pdf.url&&pdf.url.length>0){
									let title=pdf.name;
									if(pdf.text) title=pdf.text;
									let data={
										"doctitle": title,
										"filepath": "",
										"fileurl": pdf.url,
									}
									item.files.push(data);	
								}else if(pdf['RESUME_URL']&&pdf['RESUME_URL'].length>0){
									let title=pdf.RESUME_TITLE;									
									let data={
										"doctitle": title,
										"filepath": "",
										"fileurl": pdf.RESUME_URL,										
									}
									item.files.push(data);
								}	
							}							
						};							
						pdffiles.push(item);
				}else{
					let item={"parenttitle": sec.SECTION_TITLE,"files": []};
					pdffiles.push(item);
				}
				
			
			}
			if(pdffiles.length==0){
				this.spinToggle.emit('end');
				Swal.fire({
					html: ' <span style="color:red">No Appendix Data!</span>'	
				})
					
				return
			}
			let pdfFname="";
			if(this.curReport.PDF_FILE_NAME.length>0){
				pdfFname=JSON.parse(this.curReport.PDF_FILE_NAME).name.replace(/[^a-zA-Z0-9]/g, "_");
			}
			let inputJson={"r": this.r,"cid": "","appendixonly":type,"appendixCoverpagehtmlc": appCover,"mainPdf":mainPdf, "apx": pdffiles, "finalpdfname":pdfFname, "parentfilepage":response.APPENDIX_TITLEPAGE_IND,"childfilepage":response.APPENDIX_TITLEPAGE_FILE_IND,"pagesize":"Letter", 'printnodataforAppendix':this.curReport.APPENDIX_NODATA_MESSAGE};
			
			this.reportService.mergePdf2(inputJson).subscribe(result=>{
				
				//this.spinToggle.emit('end');
				
				if(result.RESPONSE_STATUS=='N'){
					this.spinToggle.emit('end');
					this.errorInfo.emit(result.MESSAGE);
					let deliverinfo={'id':this.curReport.REPORT_ID, "url":result['MESSAGE'], 'title':result.rtitle, 'status':result.RESPONSE_STATUS}
					this.delivermsg.emit(deliverinfo);
					Swal.fire({
						html: ' <p style="color:red; text-align:left">'+result.MESSAGE+'</p>'	
						
					})
						
					return
				}
				if((result.RESPONSE_STATUS=="Y")&&(result.rurl.length>0)){
					//if(this.curReport.STATUS!='Final'&&this.selectedWatermarker&&this.selectedWatermarker.WATERMARK_ID){//(type&&type=='draft'){
						//this.mergeDraft(result.rtitle, result.rurl, parseInt(this.selectedWatermarker.WATERMARK_ID));
					if(this.curReport.STATUS!='Final'&&response.WATERMARK.WATERMARK_DATA.length>0){//(type&&type=='draft'){
							this.mergeDraft(pdfFname, result.rurl, response.WATERMARK.WATERMARK_DATA);
					}else{
						//window.open(result.rurl, '_blank');
						let inputJson8= {"PROCEDURE":"updatereport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"REPORT_URL":result.rurl};
						this.reportService.univeralService(JSON.stringify(inputJson8)).subscribe(data => {
							this.spinToggle.emit('end');
							if (data.RESPONSE_STATUS=='N') {
								this.errorInfo.emit(data['MESSAGE']);
								let deliverinfo={'id':this.curReport.REPORT_ID, "url":data['MESSAGE'], 'title':result.rtitle, 'status':data.RESPONSE_STATUS}
								this.delivermsg.emit(deliverinfo);
								this.throwError(data)
								return											
							}else{
								if(this.ifPop!='N'){
									this.popInfo(result.rurl, result.rtitle);
								}
								this.okmsg.emit(this.curReport.REPORT_ID);
								let deliverinfo={'id':this.curReport.REPORT_ID, "url":result.rurl, 'title':result.rtitle, 'status':result.RESPONSE_STATUS}
								this.delivermsg.emit(deliverinfo);
							}								
						})
						/*this.spinToggle.emit('end');
						if(this.ifPop!='N'){
						this.popInfo(result.rurl, result.rtitle);
						}	
						this.okmsg.emit(this.curReport.REPORT_ID);*/
					}					
					
	
				}				
			})
			}else{
				this.spinToggle.emit('end');
				this.errorInfo.emit(response.MESSAGE);		
				let deliverinfo={'id':this.curReport.REPORT_ID, "url":response['MESSAGE'], 'title':response.rtitle, 'status':response.RESPONSE_STATUS}
				this.delivermsg.emit(deliverinfo);
				this.throwError(response);
						
				}
			})
		
	}else{
		this.spinToggle.emit('end');
		Swal.fire({
			html: ' <span style="color:red">No Appendix Defined!</span>',			
		})
			
	}
			
	}
	public toPhotoTable(photos, columns) {
		let rows = [];
		let row = [];
		for (let i = 0; i < photos.length; i++) {
			if (i % columns == 0 && row.length > 0) {
				rows.push(row);
				row = [];
			}
			row.push(photos[i]);
		}
		if (row.length > 0) {
			rows.push(row);
			row = [];
		}
		return rows;
	}
	
	getUrl(group, field1,field2,id){
		let url="";
		let index=group.findIndex(item=>item[field1]==id);
		if(index>-1){
			url=group[index][field2];			
		}
		return url;
	}
	getHtml(group, field1,type,id){//console.log(group, field1,type,id);
		let url="";
		let index=group.findIndex(item=>item[field1]==id);
		if(index>-1){
			let data=group[index];	
			
			let url=this.updateUrl(data,  type);
			return url			
		}
		
		return url;
	}
	getHtml1(data,type){//console.log(group, field1,type,id);
		let url=this.updateUrl(data,  type);
		return url			
		
	}
	updateUrl(data, type){//console.log(data)
		//let htmlData='';
		let item:any;
		if(type=='cover'){
			let jdata=JSON.parse(data.COVERPAGE_DATA);
			let outHtml=[];
			if(jdata.html){
				for(let page of jdata.html){//console.log(page)
					page=this.getRF(page);
					if(page.length==0){
						return ''
					}
					outHtml.push(page)
				}
				jdata.html=outHtml;
			}else if(jdata.ht){
				for(let item of jdata.ht){
					if(item.eData){
						item.eData=this.getRF(item.eData,'ck');
						
					}
				}
				
			}
		
			let outCHtml=this.getCoverUrl(jdata);
			return outCHtml;
		}else{
			if(type=='theader'||type=='tfooter'||type=='ffooter'){
				item=JSON.parse(data.HF_DATA);
			}else if(type=='header'){
				item=JSON.parse(data.HEADER_DATA);
			}else if(type=='footer'){
				item=JSON.parse(data.FOOTER_DATA);
			}
			//if(data.HF_DATA.length>0){
			//	item=JSON.parse(data.HF_DATA);
			if(type=='ffooter'){
				item.text=this.getRF(item.text, type);
			}else{
				item.text=this.getRF(item.text);
			}
					
				if(item.text.length>0){
					let outHFHtml=btoa(encodeURIComponent(item.text).replace(/%([0-9A-F]{2})/g, function (match, p1) {
						return String.fromCharCode(parseInt('0x' + p1, 16));
					}));
					return outHFHtml
				}else{
					return ''
				}
			/*}else{
				
				let outHFHtml="";
				return outHFHtml
			}*/			
		}	
	}
	private updateHFDate(data, type){
		const item=JSON.parse(data);
			item.text=this.getRF(item.text, type);
			if(item.text.length>0){
				let outHFHtml=btoa(encodeURIComponent(item.text).replace(/%([0-9A-F]{2})/g, function (match, p1) {
					return String.fromCharCode(parseInt('0x' + p1, 16));
				}));
			  return outHFHtml
			}else{
				return ''
			}
	}
	async getUpdated(){
		let inputJson={"PROCEDURE":"getupdatedreportinfo", "USER_ID":parseInt(this.userId), "REPORT_ID":this.curReport.REPORT_ID};
		const data=await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
			if(data.RESPONSE_STATUS=='Y'){
				if(data.PHOTOLOG_URL.length>0){
					let info={'PHOTOLOG_URL':data.PHOTOLOG_URL};
					this.curReport.PHOTOLOG_LIST[0]=info;
					this.updatePhotolog();
				}			
			}else{
					this.throwError(data)	
				}
		
		await this.getMap();
	}
	updatePhotolog(){
		if(this.curReport.PHOTOLOG_LIST[0]&&this.curReport.PHOTOLOG_LIST[0].PHOTOLOG_URL.length>0){
			for(let item of this.appendices.SUB_SECTIONS){
				if(item.app&&item.app.length>0){
					for(let rf of item.app){
						if(!rf['COPIED']&&(rf.name=="Photo Log"||rf.name=="Photo log")){
							rf['url']=this.curReport.PHOTOLOG_LIST[0].PHOTOLOG_URL;
							item['nodata']=false;
						}							
					}
				}				
			}
			
			
		}
	}
	async getMap(){
		let inputJson={"PROCEDURE":"getmapreportsbyreport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID};
		const data = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
				if(data.RESPONSE_STATUS=='Y'){
					let maps=data.RW_MAP_REPORTS;
					for(let item of this.appendices.SUB_SECTIONS){
						if(item.app&&item.app.length>0){
							for(let rf of item.app){
								if(rf.MAP_REPORT_ID){
									let index=maps.findIndex(map=>map.MAP_REPORT_ID==rf.MAP_REPORT_ID); 
									if(index>-1){
										rf['url']=maps[index].MAP_REPORT_URL;
										item['nodata']=false;
									}
									
								}							
							}
						}				
					}
				
				}else{
					this.throwError(data)	
				
				}			
			

	}
	private getRF(data, type?){//console.log(data, type)
		let that=this;
		let slots=$(data).find('.placeholder'); 
		if (slots.length==0){
			return data.trim();
		}
		for(let slot of slots){
			let key="";
			if(type){
				if(type=='ffooter'){
					key=$(slot)[0].innerText;
				}else{
					key=$(slot)[0].innerText.slice(1,-1);
				}				
			}else{
				key=$(slot)[0].innerText;
			}
			let oldDom=$(slot)[0].outerHTML;
			let newDom="";
			if(key=='Report Name'){
				newDom=this.curReport.REPORT_TITLE; 
			}else{
				let index=that.allSlots.findIndex(slot=>slot.KEY==key);
				if(index>-1){//console.log(that.allSlots[index])
					if(that.allSlots[index].CONTENT.length>0){
						newDom=that.allSlots[index].CONTENT
					}
				}
			}

			if(newDom&&newDom.length>0){
				let index=data.indexOf(oldDom);
				data=data.replaceAll(oldDom, newDom);
			}
		}
		return data;		
	}
	private rgba2hex(orig) {
		let a, isPercent,
		rgb = orig.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i),
		alpha = (rgb && rgb[4] || "").trim(),
		hex = rgb ?
		(rgb[1] | 1 << 8).toString(16).slice(1) +
		(rgb[2] | 1 << 8).toString(16).slice(1) +
		(rgb[3] | 1 << 8).toString(16).slice(1) : orig;

		if (alpha !== "") {
			a = alpha;
		} else {
			a = 0o1;
		}
		// multiply before convert to HEX
		a = ((a * 255) | 1 << 8).toString(16).slice(1)
		hex = hex + a;

		return hex;
	}
	private getCoverUrl(jdata){
		let html='';
		if(jdata.ht){
		if(this.selectpage.type=='portrait'){
			html = this.reportService.a4Portrait;
		}else if(this.selectpage.type=='landscape'){
			html = this.reportService.a4Landscape;
		}
		let hi='1036px';
		
					for(let i=0; i<jdata.ht.length; i++){
						//html+=`<div style="height:`+hi+`; margin:0; padding:`+jdata.margin.top+'px '+jdata.margin.right+'px '+jdata.margin.bottom+'px '+jdata.margin.left+'px'+`; background: url('`+jdata.ht[i].bk+`');background-repeat: no-repeat;background-size: cover;">`
						html+=`<div style="height:`+hi+`; margin:0; background: url('`+jdata.ht[i].bk+`');background-repeat: no-repeat;background-size: cover;">`
						
						html+=jdata.ht[i].eData;
						html += `</div>`;
						html += this.reportService.tagEnd;
						
					}
				}else if(jdata.html){
					for(let i=0; i<jdata.html.length; i++){
						html+=jdata.html[i];
					
						
					}
				}
			
		let content=btoa(encodeURIComponent(html).replace(/%([0-9A-F]{2})/g, function (match, p1) {
			return String.fromCharCode(parseInt('0x' + p1, 16));
		}));
		return content;
		
	}
	downloadFile(url, name){
		const link = document.createElement('a');
		link.setAttribute('target', '_blank');
		link.setAttribute('href', url);
		link.setAttribute('download', name);
		document.body.appendChild(link);
		link.click();
		link.remove();
	}
	popInfo(url, title, type?){console.log(type)
		let msg1='Your report PDF has been generated!'
		let msg2='Get PDF URL';
		let msg3='Report PDF URL copied!';
		let msg4='Share Report';
		//let msg5='Report URL copied!'
		if(type&&type=='xml'){
			msg1='Your Report Package has been generated!';
			msg2='Get Package URL';
			msg3='Report Package URL copied!'
		}
		Swal.fire({
							icon:'success',
							title: msg1,
							html: 'Would you like to download it or get a link?',
							confirmButtonText: 'Download Report',
							showLoaderOnConfirm: true,
							showDenyButton: true,
							showCancelButton: true,
							cancelButtonText: msg2,
							denyButtonText:msg4,
							denyButtonColor:"#4DB6AC",
							
							backdrop:false,													
						}).then((response) => {
							if (response.isConfirmed) {
								this.downloadFile(url, title);
							} else if (response.isDenied) {
								this.shareRpt(url);
								//Swal.fire(msg5)
							  } else if (
								response.dismiss === Swal.DismissReason.cancel
								) {
									navigator.clipboard.writeText(url);
									Swal.fire(
										msg3,									
									)
								}
						})
	}
	async shareRpt(url){
		const { value: email } = await Swal.fire({
			title: 'Input email address',
			input: 'text',//'email',
			inputLabel: 'Your email address',
			inputPlaceholder: 'Enter your email address',
			confirmButtonText: 'Share',
			inputValidator: (value) => {
				if (!value) {
				  return 'You need to write something!'
				}else if(value.indexOf('@')==-1||value.indexOf('.')==-1){
					return 'Please input a valid email'
				}
			},
		  })
		  
		  if (email) {this.spinToggle.emit('start');
			let inputJson={"PROCEDURE":"sharereportbyemail","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"SHARE_EMAIL":email}; 
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{
				this.spinToggle.emit('end');
				if(data.RESPONSE_STATUS=='Y'){						
					Swal.fire({
						title:"Success",
						html: '<p style="font-size:16px;">'+data.MESSAGE+ '</p>',
						showConfirmButton:true,
					})										
				}else{
					this.throwError(data);
				}
			}) 
			//Swal.fire(`Entered email: ${email}`)
		  }
	}
	async toxml(url, type?){//console.log(this.curReport);
		//console.log(url);
		//let inputJson=	{"company_id": "1","user_id": "5","report_id": 2325,"filename": "test","report_url": "","xmldata": ''}
		let company_id=this.curReport.REPORT_COMPANY_ID.toString()
		let report_id=this.curReport.REPORT_ID.toString();
		let user_id=this.userId.toString();
		let filename='';
		if(this.curReport.PDF_FILE_NAME.length>0){
			filename=JSON.parse(this.curReport.PDF_FILE_NAME).name.replace(/[^a-zA-Z0-9]/g, "_");
		}
		if(type){
			filename=this.xmlName;//filename+'_'+this.curReport.OUTPUT_XML_TYPE;
		}
		//let xmldata=btoa(this.xmlcontent.replace(/[\u00A0-\u2666]/g, function(c) {
		//	return '&#' + c.charCodeAt(0) + ';';
		//}));
		let xmldata=btoa(encodeURIComponent(this.xmlcontent).replace(/%([0-9A-F]{2})/g, function (match, p1) {
			return String.fromCharCode(parseInt('0x' + p1, 16));
		}));
		const result =await this.reportService.generateXML(company_id,user_id,report_id,filename,url, xmldata).toPromise();
			console.log(result)
			this.spinToggle.emit('end');
			if((result.RESPONSE_STATUS=="Y")){
				//window.open(result.XML_FILE, '_blank');	
				//this.popInfo(result.ZIP_FILE, result.REPORT_TITLE);
				return result
			}else{
				let msg=result['MESSAGE'];
				this.errorInfo.emit(msg);
				Swal.fire({
					html: ' <p style="color:red; text-align:left">'+msg+'</p>'							
				})
				return null				
			}
		
	}
	async toFrm(url, type?){//console.log(url, type);
		//console.log(url);
		//let inputJson=	{"company_id": "1","user_id": "5","report_id": 2325,"filename": "test","report_url": "","xmldata": ''}
		let company_id=this.curReport.REPORT_COMPANY_ID.toString()
		let report_id=this.curReport.REPORT_ID.toString();
		let user_id=this.userId.toString();
		let filename='';
		if(this.curReport.PDF_FILE_NAME.length>0){
			filename=JSON.parse(this.curReport.PDF_FILE_NAME).name.replace(/[^a-zA-Z0-9]/g, "_");
		}
		if(type){
			filename=this.frmSec.SECTION_TITLE;
		}
		/*let JSONdata={};
		//console.log(this.frmData.PropertyConditionAssessment)
		//console.log(this.flatPartySetSec3);
		if(this.flatPartySetSec3){
		let keys=Object.keys(this.flatPartySetSec3);
			for(let key of keys){
			  if(this.flatPartySetSec3[key]){
				//if(!this.frmData.PropertyConditionAssessment.PropertyConditionAssessmentWaterTreatment){
				//	this.frmData.PropertyConditionAssessment.PropertyConditionAssessmentWaterTreatment=[];
				//}
				this.frmData.PropertyConditionAssessment[0].PropertyConditionAssessmentWaterTreatment.push(this.flatPartySetSec3[key])
			  }
			}
		}	
		JSONdata['SchemaVersionId']=JSON.parse(JSON.stringify(this.frmData.SchemaVersionId));
		JSONdata['PropertyAmenity']=JSON.parse(JSON.stringify(this.frmData.PropertyAmenity));
		JSONdata['PropertyAsReported']=JSON.parse(JSON.stringify(this.frmData.PropertyAsReported));
		//JSONdata['PropertyAsReportedHTML']=this.frmData.PropertyAsReportedHTML;
		JSONdata['PropertyConditionAssessmentPropertyCoreCharacteristics']=JSON.parse(JSON.stringify(this.frmData.PropertyConditionAssessmentPropertyCoreCharacteristics));
		/*let keys2=Object.keys(this.frmData.PropertyConditionAssessment[0]);
		keys2.sort();
		let newJson={}
		for(let key of keys2){
			newJson[key]=JSON.parse(JSON.stringify(this.frmData.PropertyConditionAssessment[0][key]));
		}
		JSONdata['PropertyConditionAssessment']=[newJson];*/
		/*JSONdata['PropertyConditionAssessment']=JSON.parse(JSON.stringify(this.frmData.PropertyConditionAssessment));
		//JSONdata['PropertyConditionAssessmentHTML']=this.frmData.PropertyConditionAssessmentHTML;
		//JSONdata['PropertyConditionAssessmentPropertyCoreCharacteristicsHTML']=this.frmData.PropertyConditionAssessmentPropertyCoreCharacteristicsHTML;
		JSONdata['PropertyTotalRentRollSummary']=JSON.parse(JSON.stringify(this.frmData.PropertyTotalRentRollSummary));*/
		let partysec:any;
		if(this.flatPartySetSec3){
			partysec=JSON.parse(JSON.stringify(this.flatPartySetSec3))
		}
		console.log(this.frmData)
		let JSONdata=this.frmToJSON(JSON.parse(JSON.stringify(this.frmData)), partysec);console.log(JSONdata)
		//let jdata=btoa(JSON.stringify(JSONdata));
		let jdata1 = JSON.stringify(JSONdata, null, 2);//console.log(jdata1)
		//let jdata=btoa(jdata1.replace(/[\u00A0-\u2666]/g, function(c) {
		//	return '&#' + c.charCodeAt(0) + ';';
		//}));
		let jdata=btoa(encodeURIComponent(jdata1).replace(/%([0-9A-F]{2})/g, function (match, p1) {
			return String.fromCharCode(parseInt('0x' + p1, 16));
		}));
		//console.log(company_id,user_id,report_id,filename,url, jdata);
		const result =await this.reportService.generateJSON(company_id,user_id,report_id,filename,url, jdata).toPromise();
			console.log(result)
			this.spinToggle.emit('end');
			if((result.RESPONSE_STATUS=="Y")){
				return result
			}else{
				let msg=result['MESSAGE'];
				this.errorInfo.emit(msg);
				Swal.fire({
					html: ' <p style="color:red; text-align:left">'+msg+'</p>'							
				})
				return null				
			}
		
	}
	replaceErisTable(resourceHtml, type?){//console.log(resourceHtml)
		let ifTemp=type?true:false;
		for(let doc of this.contents){
			if(doc.SUB_SECTIONS&&doc.SUB_SECTIONS.length>0){
				for(let doc1 of doc.SUB_SECTIONS){
						if(doc1.TYPE=='TABLE'&&doc1.data&&doc1.data.erisName&&doc1.data.rows.length>0){
							if(!doc1.OTABLE){
								let targetHtml=this.getErisHtml(doc1, ifTemp);//console.log(targetHtml)
								let erisId='#'+doc1.id+'table';//console.log($(erisId)[0])
								if($(erisId)[0]){
									let target=$(erisId)[0].outerHTML;
									resourceHtml=resourceHtml.replace(target,targetHtml);
								}
								
							}
						}
						if(doc1.SUB_SECTIONS&&doc1.SUB_SECTIONS.length>0){
							for(let doc2 of doc1.SUB_SECTIONS){
								if(doc2.TYPE=='TABLE'&&doc2.data&&doc2.data.erisName&&doc2.data.rows.length>0){
									if(!doc2.OTABLE){
										let targetHtml1=this.getErisHtml(doc2, ifTemp);//console.log(targetHtml1)
										let erisId1='#'+doc2.id+'table';//console.log($(erisId1)[0])
										if($(erisId1)[0]){
											let target1=$(erisId1)[0].outerHTML;
											resourceHtml=resourceHtml.replace(target1,targetHtml1)
										}
									}
								}
							}
						}
						
					}
			}
			
		}
		return resourceHtml
	}
	private getErisHtml(doc, type){
		let tabledata=doc.data
		let erisHtml='<table style="width: 100%; margin-top: 20px;"><thead><tr>';
		if(doc['borderClass']){
			erisHtml='<table class="'+doc['borderClass']+'"style="width: 100%; margin-top: 20px;"><thead><tr>'	
		}
		let cols=tabledata.cols
		for(let col of cols){
			if(!col.hide){
				let alginStyle='center';
				if(col.colAlign=='Left'){
					alginStyle='left'
				}else if(col.colAlign=='Right'){
					alginStyle='right'
				}else if(col.colAlign=='Center'){
					alginStyle='center'
				}
				erisHtml+='<th style="width:'+col.width+col.unit+';text-align:'+alginStyle+'"><span style="font-weight: bold;">'+ col.NAME+'</span></th>';
			}
					
		}
		erisHtml+='</tr></thead><tbody>';
		if(tabledata.rows.length>0){
			for(let row of tabledata.rows){
				erisHtml+='<tr>';
				if(row.length>0){
					if(row[0].SUBHEADER=='Y'){//	console.log(row.length)					
							if(row[1].HTML){
								let posi='Center';
								if(row[0].celAllign){
									posi=row[0].celAllign;
								}
								//let item="<td colspan="+(row.length-1)+" style='text-align: center; vertical-align: top;' ><div style='text-align:center' innerHTML='"+row[1].HTML+"'></div></td>"; console.log(item)
								//erisHtml+='<td colspan='+(row.length-1)+' style="text-align: center; vertical-align: top;" ><div style="text-align:center" innerHTML='+row[1].HTML+'</div></td>';
								erisHtml+='<td colspan='+(row.length-1)+' style="text-align: '+posi+'; vertical-align: top;" ><span innerHTML='+row[1].HTML+'</span></td>';

							}else{
								erisHtml+='<td colspan='+(row.length-1)+' style="text-align: center; vertical-align: top" ><div style="text-align:center">'+row[1].DATA+'</div></td>';
							}						
					}else{
						for(let i=1; i<row.length; i++){							
							if(!row[i]['hide']){
								let alginClass='align-left';
								if(cols[i].celAllign=='Left'){
									alginClass='align-left'
								}else if(cols[i].celAllign=='Right'){
									alginClass='align-right'
								}else if(cols[i].celAllign=='Center'){
									alginClass='align-center'
								}
								if((!this.curReport.ORDER_NUM&&!tabledata.disableCopiedEris)||type){
									erisHtml+='<td class="'+alginClass+'" style="vertical-align: top; width: '+cols[i].width+cols[i].unit+'; text-align: '+cols[i].celAllign+'" ></td>';
								}else if(row[i].HTML){
									erisHtml+='<td class="'+alginClass+'" style="vertical-align: top; width: '+cols[i].width+cols[i].unit+'; text-align: '+cols[i].celAllign+'" >'+row[i].HTML+'</td>';
								}else{
									erisHtml+='<td class="'+alginClass+'" style="vertical-align: top; width: '+cols[i].width+cols[i].unit+'; text-align: '+cols[i].celAllign+'" ><span >'+row[i].DATA+'</span></td>';
								}								
							}	
						}	
					}
				}
				erisHtml+='</tr>';						
			}
		}
		erisHtml+='</tbody></table>';
		return erisHtml
	}
	addon:string;
	checkIndent(){
		for(let i=0; i<this.contents.length; i++){
			if(this.contents[i].SUB_SECTIONS){
				for(let j=0; j<this.contents[i].SUB_SECTIONS.length; j++){
					if(this.contents[i].SUB_SECTIONS[j].DISPLAY_SEQUENCE=='N'){
						let secIndex=[i,j,this.addon];
						this.contents[i].SUB_SECTIONS[j]['noIndent']=this.checkLevel(secIndex); 						
					}else{
						if(this.contents[i].SUB_SECTIONS[j]['noIndent']){
							delete this.contents[i].SUB_SECTIONS[j]['noIndent'];
						}
						
					}
					if(this.contents[i].SUB_SECTIONS[j].SUB_SECTIONS){
						for(let k=0; k<this.contents[i].SUB_SECTIONS[j].SUB_SECTIONS.length; k++){
							if(this.contents[i].SUB_SECTIONS[j].SUB_SECTIONS[k].DISPLAY_SEQUENCE=='N'){
								let secIndex1=[i,j,k];
								this.contents[i].SUB_SECTIONS[j].SUB_SECTIONS[k]['noIndent']=this.checkLevel(secIndex1);			
							}else{
								if(this.contents[i].SUB_SECTIONS[j].SUB_SECTIONS[k]['noIndent']){
									delete this.contents[i].SUB_SECTIONS[j].SUB_SECTIONS[k]['noIndent']
								}
							}
						}
					}
								
				}
			}
		}
	}
	checkLevel(curIndex){
		let index1=curIndex[0];
		let index2=curIndex[1];
		let index3=curIndex[2];
		let indent:number;
		if(index3>-1){
			for(let i=index3; i>-1; i--){
				if(this.contents[index1].SUB_SECTIONS[index2]&&this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[i-1]&&this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[i-1].DISPLAY_SEQUENCE=='Y'){
					indent=3;
					break
				}
			}
		}
		if(!indent&&index2>-1){
			for(let i=index2; i>-1; i--){
				if(this.contents[index1].SUB_SECTIONS[i]&&this.contents[index1].SUB_SECTIONS[i].DISPLAY_SEQUENCE=='Y'){
					indent=2;
					break
				}
			}	
		}
		if(!indent){
			indent=1;
		}
		return indent;	
	}
	
	//public PropertyAsReported:any;
	public PropertyAsReportedHTML:any;  
	public PropertyConditionAssessmentPropertyCoreCharacteristics:any;
	public PropertyConditionAssessmentPropertyCoreCharacteristicsHTML:any;
	public PropertyConditionAssessment:any;
	public PropertyConditionAssessmentHTML:any;
	public frmData:any;
	public PropertyAmenity:any;
	public PropertyTotalRentRollSummary:any;
	public flatDataAmentities:any;
	public flatData:any;
	public flatDataSec2:any;
	public flatDataSec3:any;
	public flatDataSetSec3:any;
	public flatPartySetSec3:any
	public flatDataSec4:any;
	public flatDataSetSec4:any;
	public tableset:any;
	public sec2tablesdata:any[];
	public sec3tablesdata:any[];
	public sec6tablesdata:any[];
	public pcaOp={'term':'Include','multiplier':"",'quantity':0, 'reserve':12, 'age':0, 'decimal':2,'currency':'USD','inflation':2.5,'round':'Round'};
	public costTables:any[];
	public curSec:any;	
	public curCell:any;	
	public cellShow:any;
	public datasrc:boolean;	
	public bedroomList=['0BR', '1BR', '2BR', '3BR', '4BR', '5BR'];
	public bedroomStatus=['O = occupied', 'V = vacant', 'D = down','R = Other'];
	public unitrow=1
	public ORrows=[];
	public repairTotal=0;
	//waterCheck=[false, false, false, false, false];
	waters=['privateWellsDrinkingWater','privateWellsNonDrinkingWater','wasteWaterTreatment', 'privateLiftStations'];
	repairtCount=[false,false,false,false,false, false];
	frmSec:any;
	frmsearchstring:string;
	iniFrmdata(){
		if(this.curReport&&this.curReport.PCA_INDICATOR=='frm1104'){
			this.frmsearchstring='frm_sec'+Utils.uniqueIdGenerator();
			if(this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit.length==0){
				this.unitrow=1
			}else{
				this.unitrow=Math.ceil(this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit.length/4);      
			}
			return
		}else if(this.curReport&&this.curReport.PHASE1_TYPE&&this.curReport.PHASE1_TYPE=='1103'){
			this.frmsearchstring='frm_sec'+Utils.uniqueIdGenerator();
			if(this.contents[2].SUB_SECTIONS[0].data.units.length==0){
				this.unitrow=5;
				for(let i=0; i<20; i++){
					this.contents[2].SUB_SECTIONS[0].data.units.push("");
				} 
			}else{
				this.unitrow=Math.ceil(this.contents[2].SUB_SECTIONS[0].data.units.length/4);  
			
			}
			return
		}
			
		for(let sec of this.contents){
			if(sec.TYPE=='1105'&&(sec.id='frm_sec')){
				this.frmSec=sec;
				sec['searchstring']=sec.id+Utils.uniqueIdGenerator();
				this.frmData = JSON.parse(JSON.stringify(sec.frmData));			
				//if(this.frmData['AccountNameHTML']){
				//this.AccountNameHTML=this.frmData['AccountNameHTML'];
				//}
				if(!this.frmData['sec4OutPutData']){
					this.frmData['sec4OutPutData']=[0, '$0'];
				}
				if(this.frmData['repairtCount']){
					this.repairtCount=this.frmData['repairtCount'];
				}
				if(this.frmData['flatPartySetSec3']){
					this.flatPartySetSec3=this.frmData['flatPartySetSec3'];
				  }
				 if(this.frmData['repairtCount']){
				   this.repairtCount= this.frmData['repairtCount'];
				  }
				if(this.frmData['sec2tablesdata']){
				this.sec2tablesdata=this.frmData['sec2tablesdata'];
				}else{
				this.frmData['sec2tablesdata']=this.sec2tablesdata;
				}
				if(this.frmData['sec3tablesdata']){
				this.sec3tablesdata=this.frmData['sec3tablesdata'];
				}else{
				this.frmData['sec3tablesdata']=this.sec3tablesdata;
				}
				if(this.frmData['sec6tablesdata']){
				this.sec6tablesdata=this.frmData['sec6tablesdata'];
				}else{
				this.frmData['sec6tablesdata']=this.sec6tablesdata;
				}
				if(this.frmData['ORrows']){
					this.ORrows=this.frmData['ORrows'];
				}
				
				this.PropertyAsReportedHTML=this.frmData.PropertyAsReportedHTML;
				this.PropertyConditionAssessmentPropertyCoreCharacteristicsHTML=this.frmData.PropertyConditionAssessmentPropertyCoreCharacteristicsHTML;
				this.PropertyConditionAssessmentHTML=this.frmData.PropertyConditionAssessmentHTML;
				this.toSanitizer();
				this.PropertyAmenity=this.frmData.PropertyAmenity;
				//this.PropertyAsReported=this.frmData.PropertyAsReported;
				this.PropertyConditionAssessmentPropertyCoreCharacteristics=this.frmData.PropertyConditionAssessmentPropertyCoreCharacteristics;
				this.toFlat(this.frmData.PropertyConditionAssessment[0]);
				this.PropertyConditionAssessment=this.frmData.PropertyConditionAssessment;
				
				let fields=['AtInpectionWeatherDescription','PrelimInspectionDate','FinalAsmntDate','FirmAddressLineText','FirmCityName','FirmName','FirmPostalCode','FirmStateUspsCode','InspectorName','InspectorPhoneNumber','InspectorTitle','OnsiteContactName','OnsiteContactPhoneNumber',];
				//let fields=['AtInpectionWeatherDescription','FirmAddressLineText','FirmCityName','FirmName','FirmPostalCode','FirmStateUspsCode','InspectorName','InspectorPhoneNumber','InspectorTitle','OnsiteContactName','OnsiteContactPhoneNumber',];
				
				for(let field of fields){
					if(!(field=="PrelimInspectionDate"||field=="FinalAsmntDate")&&this.PropertyConditionAssessmentHTML[field]&&this.PropertyConditionAssessmentHTML[field].html.length>0){
						if($(this.PropertyConditionAssessmentHTML[field].html).find('.placeholder').length>0){
							this.PropertyConditionAssessment[0][field]=$(this.PropertyConditionAssessmentHTML[field].html.replace('<p>','').replace('</p>',''))[0].innerHTML;	
						}else{
							this.PropertyConditionAssessment[0][field]=this.PropertyConditionAssessmentHTML[field].html.replace('<p>','').replace('</p>','');
						}
						//this.PropertyConditionAssessment[0][field]=$(this.PropertyConditionAssessmentHTML[field].html.replace('<p>','').replace('</p>',''))[0].innerHTML;
					}else if(field=="PrelimInspectionDate"||field=="FinalAsmntDate") {
						this.PropertyConditionAssessment[0][field]=this.PropertyConditionAssessmentHTML[field];
					}
				}
				this.PropertyTotalRentRollSummary=this.frmData.PropertyTotalRentRollSummary;
				
				if(this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit.length==0){
				this.unitrow=1
				}else{
					this.unitrow=Math.ceil(this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit.length/4);      
				}
			}
		}
		//this.checksplit();
	}
	toSanitizer(){
		if(this.PropertyAsReportedHTML){
		  let items=[this.PropertyAsReportedHTML,this.PropertyConditionAssessmentHTML, this.PropertyConditionAssessmentPropertyCoreCharacteristicsHTML];
		  for(let item of items){
			let keys=Object.keys(item);
			for(let key of keys){
			  if(!item[key].secHtml&&item[key].html){
				item[key].secHtml=this.sanitizer.bypassSecurityTrustHtml(item[key].html);
			  }
			}
			
		  }
		  
		}
	
	  }
	  toFlat(alldata){
		this.flatDataAmentities=[];
		for(let data of this.PropertyAmenity){
		  this.flatDataAmentities.push(data.AmenityType);
		}
		
		this.flatData=[];
		for(let data of alldata.PropertyConditionAssessmentBuildingAndMaterials){
		   if(data.CatSubtype){
			  let text=data.CatType+';'+data.CatSubtype+';'+data.ItemType;
			  this.flatData.push(text);
			}else{
			  let text=data.CatType+';'+data.ItemType
			  this.flatData.push(text);
			}    
		}
	   // console.log(this.flatData);
		this.flatDataSec3={};
		this.flatDataSetSec3={};//console.log(alldata.PropertyConditionAssessmentWaterTreatment)
		for(let i=0; i<this.waters.length; i++){
			//if(i==1){
			//   let item={"PptyWaterSystemType": "privateWellsNonDrinkingWater",
			//	"WaterSystemOperationsDescription": ""};
			//	this.flatDataSec3[this.waters[i]]=['privateWellsNonDrinkingWater'];
			//	this.flatDataSetSec3[this.waters[i]]=[item];               
			//}else{
			  this.flatDataSec3[this.waters[i]]=[];
			  this.flatDataSetSec3[this.waters[i]]=[]; 
			//}      
		  }
		if(alldata.PropertyConditionAssessmentWaterTreatment.length>0){
		for(let data of alldata.PropertyConditionAssessmentWaterTreatment){//console.log(data)
		  if(this.flatDataSec3[data.PptyWaterSystemType]){
			if(data.WaterSystemMaintenanceResponsiblePartyType){
			  this.flatDataSec3[data.PptyWaterSystemType].push(data.WaterSystemMaintenanceResponsiblePartyType);
			}else if(data.PptyWaterSystemSubType){
				this.flatDataSec3[data.PptyWaterSystemType].push(data.PptyWaterSystemSubType);
			  }else if(data.PptyWaterSystemType=="privateWellsNonDrinkingWater"){
				this.flatDataSec3[data.PptyWaterSystemType][0]=data.PptyWaterSystemType;
			}else{
			  this.flatDataSec3[data.PptyWaterSystemType].push(data.WaterSystemAsmntItemType);
			  
			}
			if(data.PptyWaterSystemType=="privateWellsNonDrinkingWater"){
				this.flatDataSetSec3[data.PptyWaterSystemType][0]=data;
			}else{
				this.flatDataSetSec3[data.PptyWaterSystemType].push(data);
			} 
			
		  }else{
			this.flatDataSec3[data.PptyWaterSystemType]=[];
			this.flatDataSetSec3[data.PptyWaterSystemType]=[];
			this.flatDataSetSec3[data.PptyWaterSystemType].push(data);
			if(data.WaterSystemMaintenanceResponsiblePartyType){
			  this.flatDataSec3[data.PptyWaterSystemType].push(data.WaterSystemMaintenanceResponsiblePartyType);
			}else if(data.PptyWaterSystemSubType){
			  this.flatDataSec3[data.PptyWaterSystemType].push(data.PptyWaterSystemSubType);
			}else if(data.PptyWaterSystemType=="privateWellsNonDrinkingWater"){
				this.flatDataSec3[data.PptyWaterSystemType][0]=data.PptyWaterSystemType;
			}else{
			  this.flatDataSec3[data.PptyWaterSystemType].push(data.WaterSystemAsmntItemType);
			  
			}
		  }
		 /* for(let i=0; i<this.waters.length; i++){
			if(this.flatDataSec3[this.waters[i]]&&this.flatDataSec3[this.waters[i]].length>0){
			  this.waterCheck[i]=true;
			}else if(this.flatPartySetSec3[this.waters[i]]){
				this.flatDataSec3[this.waters[i]]=[];
				this.flatDataSetSec3[this.waters[i]]=[];
				this.waterCheck[i]=true;
			  }else{
			  this.waterCheck[i]=false;
			}
		  }*/
		}
	}

		this.flatDataSec4={};
		this.flatDataSetSec4={};
		if(alldata.PropertyConditionAssessmentManufacturedHousing.length>0){
			for(let data of alldata.PropertyConditionAssessmentManufacturedHousing){
				if(this.flatDataSec4["PropertyConditionAssessmentManufacturedHousing"]){
				  this.flatDataSec4["PropertyConditionAssessmentManufacturedHousing"].push(data.ViolationType);
				  this.flatDataSetSec4["PropertyConditionAssessmentManufacturedHousing"].push(data);
				}else{
				  this.flatDataSec4["PropertyConditionAssessmentManufacturedHousing"]=[];
				  this.flatDataSetSec4["PropertyConditionAssessmentManufacturedHousing"]=[];
				  this.flatDataSetSec4["PropertyConditionAssessmentManufacturedHousing"].push(data);
				  this.flatDataSec4["PropertyConditionAssessmentManufacturedHousing"].push(data.ViolationType);
					
				  
				}
			  }
		}else{
			this.flatDataSec4["PropertyConditionAssessmentManufacturedHousing"]=[];
			this.flatDataSetSec4["PropertyConditionAssessmentManufacturedHousing"]=[];
		}
		
		if(alldata.ManufacturedHousingUtility.length>0){
			for(let data of alldata.ManufacturedHousingUtility){
			if(this.flatDataSec4['ManufacturedHousingUtility']){
				this.flatDataSec4['ManufacturedHousingUtility'].push(data.UtilityServiceType);
				this.flatDataSetSec4['ManufacturedHousingUtility'].push(data);
			}else{
				this.flatDataSec4['ManufacturedHousingUtility']=[];
				this.flatDataSetSec4['ManufacturedHousingUtility']=[];
				this.flatDataSetSec4['ManufacturedHousingUtility'].push(data);
				this.flatDataSec4['ManufacturedHousingUtility'].push(data.UtilityServiceType);		
			}
			}
		}else{
			this.flatDataSec4['ManufacturedHousingUtility']=[];
			this.flatDataSetSec4['ManufacturedHousingUtility']=[];
		}
		
		//console.log(this.flatDataSec4);
		//console.log(this.flatDataSetSec4);
	
	  }
	private throwError(data){
		if(data.RESPONSE_STATUS=='N'&&data.ERRORCODE == '9'){
			console.log('Timeout');
			Swal.fire({
				html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',
			})
			this.cookieService.clearAll();
			this.router.navigate(['/']);			
		}/*else{
			Swal.fire({
				html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',
			})
		}*/
	  }
	  frmToJSON(alldata, sec4Data){console.log(sec4Data)
		// Use JSON.parse(JSON.stringify()) to deep clone to modify actual data
		let newAllData = JSON.parse(JSON.stringify(alldata));
		let newSec4Data:any;
		if(sec4Data){
			newSec4Data = JSON.parse(JSON.stringify(sec4Data));
		}
		

		let json: any = {};
		let order: any;
		let property: any;

		if (newSec4Data) {
			let keys = Object.keys(newSec4Data);
			for (let key of keys) {
				if (newSec4Data[key]) {
					newAllData.PropertyConditionAssessment[0].PropertyConditionAssessmentWaterTreatment.push(newSec4Data[key])
				}
			}
		}
		// Remove HTML tags from all string fields
		if(newAllData.PropertyAsReported[0]){
			let keys = Object.keys(newAllData.PropertyAsReported[0]);
			for (let key of keys) {
				if (newAllData.PropertyAsReported[0][key]) {
					newAllData.PropertyAsReported[0][key]=newAllData.PropertyAsReported[0][key].replace(/<[^>]*>/g, "");
				}
			}
		}
		// Using a ques (?) flag for code that may require a different strategy
		// Using a dash (-) flag for code that have an error still

		json.SchemaVersionId = newAllData.SchemaVersionId;

		json.PropertyAmenity = newAllData.PropertyAmenity;
		if (json.PropertyAmenity.length === 0) {
			delete json.PropertyAmenity;
		}

		json.PropertyAsReported = newAllData.PropertyAsReported;
		delete json.PropertyAsReported[0].FrmLoanNo;

		json.PropertyConditionAssessmentPropertyCoreCharacteristics = newAllData.PropertyConditionAssessmentPropertyCoreCharacteristics;
		// Remove attribute
		delete json.PropertyConditionAssessmentPropertyCoreCharacteristics[0].TotalUnitCount;
		// Cast to number
		json.PropertyConditionAssessmentPropertyCoreCharacteristics[0].PptyBuildingAgeYrCount = +json.PropertyConditionAssessmentPropertyCoreCharacteristics[0].PptyBuildingAgeYrCount || 0;
		json.PropertyConditionAssessmentPropertyCoreCharacteristics[0].PptyFloorCount = +json.PropertyConditionAssessmentPropertyCoreCharacteristics[0].PptyFloorCount || 0;
		json.PropertyConditionAssessmentPropertyCoreCharacteristics[0].PptyNonRsdntlBuildingCount = +json.PropertyConditionAssessmentPropertyCoreCharacteristics[0].PptyNonRsdntlBuildingCount || 0;
		json.PropertyConditionAssessmentPropertyCoreCharacteristics[0].PptyRsdntlBuildingCount = +json.PropertyConditionAssessmentPropertyCoreCharacteristics[0].PptyRsdntlBuildingCount || 0;

		// Rebuilding PropertyConditionAssessment from scratch because everything is out of order
		json.PropertyConditionAssessment = [{}];
		json.PropertyConditionAssessment[0].CapitalExpenditureMrtgTermYrCount = newAllData.PropertyConditionAssessment[0].CapitalExpenditureMrtgTermYrCount;
		json.PropertyConditionAssessment[0].CapitalExpenditureTotalLoanTermUninflatedAmt = newAllData.PropertyConditionAssessment[0].CapitalExpenditureTotalLoanTermUninflatedAmt;
		json.PropertyConditionAssessment[0].CapitalExpenditureTotalLoanTermInflatedAmt = newAllData.PropertyConditionAssessment[0].CapitalExpenditureTotalLoanTermInflatedAmt;
		json.PropertyConditionAssessment[0].CapitalExpenditureUnitAnnualUninflatedAmt = newAllData.PropertyConditionAssessment[0].CapitalExpenditureUnitAnnualUninflatedAmt;
		json.PropertyConditionAssessment[0].CapitalExpenditureUnitAnnualInflatedAmt = newAllData.PropertyConditionAssessment[0].CapitalExpenditureUnitAnnualInflatedAmt;
		json.PropertyConditionAssessment[0].FirmName = newAllData.PropertyConditionAssessment[0].FirmName.replace(/<[^>]*>/g, "");
		json.PropertyConditionAssessment[0].FirmPostalCode = newAllData.PropertyConditionAssessment[0].FirmPostalCode.replace(/<[^>]*>/g, "");
		json.PropertyConditionAssessment[0].FirmCityName = newAllData.PropertyConditionAssessment[0].FirmCityName.replace(/<[^>]*>/g, "");
		json.PropertyConditionAssessment[0].FirmStateUspsCode = newAllData.PropertyConditionAssessment[0].FirmStateUspsCode.replace(/<[^>]*>/g, "");
		json.PropertyConditionAssessment[0].FirmAddressLineText = newAllData.PropertyConditionAssessment[0].FirmAddressLineText.replace(/<[^>]*>/g, "");
		json.PropertyConditionAssessment[0].InspectorPhoneNumber = newAllData.PropertyConditionAssessment[0].InspectorPhoneNumber.replace(/<[^>]*>/g, "");
		json.PropertyConditionAssessment[0].InspectorTitle = newAllData.PropertyConditionAssessment[0].InspectorTitle.replace(/<[^>]*>/g, "");
		json.PropertyConditionAssessment[0].InspectorName = newAllData.PropertyConditionAssessment[0].InspectorName.replace(/<[^>]*>/g, "");
		json.PropertyConditionAssessment[0].ManufacturedHousingInd = newAllData.PropertyConditionAssessment[0].ManufacturedHousingInd;
		if(newAllData.PropertyConditionAssessment[0].ManufacturedHousingPadSiteSizeDescription){
			json.PropertyConditionAssessment[0].ManufacturedHousingPadSiteSizeDescription = newAllData.PropertyConditionAssessment[0].ManufacturedHousingPadSiteSizeDescription.replace(/<[^>]*>/g, "");
		}else{
			json.PropertyConditionAssessment[0].ManufacturedHousingPadSiteSizeDescription = "";
		}
		json.PropertyConditionAssessment[0].OnsiteContactName = newAllData.PropertyConditionAssessment[0].OnsiteContactName.replace(/<[^>]*>/g, "");
		json.PropertyConditionAssessment[0].AtInpectionWeatherDescription = newAllData.PropertyConditionAssessment[0].AtInpectionWeatherDescription.replace(/<[^>]*>/g, "");
		json.PropertyConditionAssessment[0].OnsiteContactPhoneNumber = newAllData.PropertyConditionAssessment[0].OnsiteContactPhoneNumber.replace(/<[^>]*>/g, "");//.replace(/\D/g, '');;
		json.PropertyConditionAssessment[0].FinalAsmntDate = isNaN(new Date(newAllData.PropertyConditionAssessment[0].FinalAsmntDate).getTime())
															? "" : new Date(newAllData.PropertyConditionAssessment[0].FinalAsmntDate).toISOString();
		json.PropertyConditionAssessment[0].PrelimInspectionDate = isNaN(new Date(newAllData.PropertyConditionAssessment[0].PrelimInspectionDate).getTime())
																? "" : new Date(newAllData.PropertyConditionAssessment[0].PrelimInspectionDate).toISOString();
		json.PropertyConditionAssessment[0].RsdntlDownInspectedUnitCount = newAllData.PropertyConditionAssessment[0].RsdntlDownInspectedUnitCount;
		json.PropertyConditionAssessment[0].RsdntlOccupiedInspectedUnitCount = newAllData.PropertyConditionAssessment[0].RsdntlOccupiedInspectedUnitCount;
		json.PropertyConditionAssessment[0].RsdntlOtherInspectedUnitCount = newAllData.PropertyConditionAssessment[0].RsdntlOtherInspectedUnitCount;
		json.PropertyConditionAssessment[0].RsdntlVacantInspectedUnitCount = newAllData.PropertyConditionAssessment[0].RsdntlVacantInspectedUnitCount;

		// reordering ManufacturedHousingUtility object elements
		order = ["municipalWater", "privateWater", "electric", "gas", "municipalSewer", "privateSewer", "other"];
		property = 'UtilityServiceType';
		json.PropertyConditionAssessment[0].ManufacturedHousingUtility = newAllData.PropertyConditionAssessment[0].ManufacturedHousingUtility.sort((a: any, b: any) => {
			return order.indexOf(a[property]) - order.indexOf(b[property]);
		});
		if (json.PropertyConditionAssessment[0].ManufacturedHousingUtility.length === 0) {
			delete json.PropertyConditionAssessment[0].ManufacturedHousingUtility;
		}

		json.PropertyConditionAssessment[0].PropertyCapitalExpenditureProjection = newAllData.PropertyConditionAssessment[0].PropertyCapitalExpenditureProjection;
		json.PropertyConditionAssessment[0].PropertyCapitalExpenditureProjection = json.PropertyConditionAssessment[0].PropertyCapitalExpenditureProjection.filter(item => item.YrNumber !== 0);

		// ?- one element is out of position, this may just be easier and makes more sense to fix in loading newAllData before the json modification
		// {
		//     "CatType": "electrical",
		//     "ItemType": "unitCapacityAmps",
		//     "OtherItemDescription": "123"
		// }
		// sort attributes first
		// this is unfortunately the only way to sort it because the order is arbitrary
		const PropertyConditionAssessmentItemOrder = [
			{
					"CatType": "buildingType",
					"ItemType": "garden"
			},
			{
					"CatType": "buildingType",
					"ItemType": "walkUp"
			},
			{
					"CatType": "buildingType",
					"ItemType": "elevator"
			},
			{
					"CatType": "buildingType",
					"CatSubtype": "elevator",
					"ItemType": "lowrise"
			},
			{
					"CatType": "buildingType",
					"CatSubtype": "elevator",
					"ItemType": "midrise"
			},
			{
					"CatType": "buildingType",
					"CatSubtype": "elevator",
					"ItemType": "highrise"
			},
			{
					"CatType": "buildingType",
					"ItemType": "townhouse"
			},
			{
					"CatType": "buildingType",
					"ItemType": "other",
			},
			{
					"CatType": "constructionType",
					"ItemType": "woodFrame"
			},
			{
					"CatType": "constructionType",
					"ItemType": "metalFrame"
			},
			{
					"CatType": "constructionType",
					"ItemType": "structuralSteel"
			},
			{
					"CatType": "constructionType",
					"ItemType": "masonry"
			},
			{
					"CatType": "constructionType",
					"ItemType": "structuralConcrete"
			},
			{
					"CatType": "constructionType",
					"ItemType": "flatRoof"
			},
			{
					"CatType": "constructionType",
					"ItemType": "pitchedRoof"
			},
			{
					"CatType": "constructionType",
					"ItemType": "flatRoofWithMansards"
			},
			{
					"CatType": "constructionType",
					"ItemType": "fireTreatedPlywood"
			},
			{
					"CatType": "constructionType",
					"ItemType": "other",
			},
			{
					"CatType": "foundationType",
					"ItemType": "slabOnGrade"
			},
			{
					"CatType": "foundationType",
					"ItemType": "concretePierDrilled"
			},
			{
					"CatType": "foundationType",
					"ItemType": "spreadRaisedFoundation"
			},
			{
					"CatType": "foundationType",
					"ItemType": "undergroundParkingStructure"
			},
			{
					"CatType": "foundationType",
					"ItemType": "other",
			},
			{
					"CatType": "parking",
					"ItemType": "surfaceUncovered"
			},
			{
					"CatType": "parking",
					"ItemType": "structured"
			},
			{
					"CatType": "parking",
					"CatSubtype": "structured",
					"ItemType": "carports"
			},
			{
					"CatType": "parking",
					"CatSubtype": "structured",
					"ItemType": "garages"
			},
			{
					"CatType": "parking",
					"CatSubtype": "structured",
					"ItemType": "underground"
			},
			{
					"CatType": "envelope",
					"ItemType": "stucco"
			},
			{
					"CatType": "envelope",
					"ItemType": "woodSiding"
			},
			{
					"CatType": "envelope",
					"CatSubtype": "woodSiding",
					"ItemType": "t111"
			},
			{
					"CatType": "envelope",
					"CatSubtype": "woodSiding",
					"ItemType": "masonite"
			},
			{
					"CatType": "envelope",
					"CatSubtype": "woodSiding",
					"ItemType": "planking"
			},
			{
					"CatType": "envelope",
					"ItemType": "vinylSiding"
			},
			{
					"CatType": "envelope",
					"ItemType": "brickVeneer"
			},
			{
					"CatType": "envelope",
					"ItemType": "metalDoors"
			},
			{
					"CatType": "envelope",
					"ItemType": "woodDoors"
			},
			{
					"CatType": "envelope",
					"ItemType": "woodSashWindows"
			},
			{
					"CatType": "envelope",
					"ItemType": "aluminumWindows"
			},
			{
					"CatType": "envelope",
					"ItemType": "other",
			},
			{
					"CatType": "elevators",
					"ItemType": "numberOfCabs",
			},
			{
					"CatType": "elevators",
					"ItemType": ""
			},
			{
					"CatType": "elevators",
					"ItemType": "lastInspectionDate",
			},
			{
					"CatType": "mechanicalsPlumbing",
					"ItemType": "galvanizedWaterPiping"
			},
			{
					"CatType": "mechanicalsPlumbing",
					"ItemType": "copperWaterPiping"
			},
			{
					"CatType": "mechanicalsPlumbing",
					"ItemType": "polybutyleneWaterPiping"
			},
			{
					"CatType": "mechanicalsPlumbing",
					"ItemType": "castIronWaste"
			},
			{
					"CatType": "mechanicalsPlumbing",
					"ItemType": "absPvcWaste"
			},
			{
					"CatType": "mechanicalsPlumbing",
					"ItemType": "centralWaterHeater"
			},
			{
					"CatType": "mechanicalsPlumbing",
					"CatSubtype": "centralWaterHeater",
					"ItemType": "gas"
			},
			{
					"CatType": "mechanicalsPlumbing",
					"CatSubtype": "centralWaterHeater",
					"ItemType": "electric"
			},
			{
					"CatType": "mechanicalsPlumbing",
					"ItemType": "individualWaterHeaters"
			},
			{
					"CatType": "mechanicalsPlumbing",
					"CatSubtype": "individualWaterHeaters",
					"ItemType": "gas"
			},
			{
					"CatType": "mechanicalsPlumbing",
					"CatSubtype": "individualWaterHeaters",
					"ItemType": "electric"
			},
			{
					"CatType": "mechanicalsPlumbing",
					"ItemType": "circulatingHotWater"
			},
			{
					"CatType": "mechanicalsPlumbing",
					"ItemType": "other",
			},
			{
					"CatType": "mechanicalsHvac",
					"ItemType": "centralBoilerSteamHeat"
			},
			{
					"CatType": "mechanicalsHvac",
					"ItemType": "hydronicSystem"
			},
			{
					"CatType": "mechanicalsHvac",
					"ItemType": "gasFauCentral"
			},
			{
					"CatType": "mechanicalsHvac",
					"ItemType": "electricFauCentral"
			},
			{
					"CatType": "mechanicalsHvac",
					"ItemType": "electricBaseboardHeat"
			},
			{
					"CatType": "mechanicalsHvac",
					"ItemType": "wallMountedAcUnit"
			},
			{
					"CatType": "mechanicalsHvac",
					"ItemType": "acCondenserUnits"
			},
			{
					"CatType": "mechanicalsHvac",
					"ItemType": "evaporativeCoolerUnit"
			},
			{
					"CatType": "mechanicalsHvac",
					"ItemType": "otherHeat",
			},
			{
					"CatType": "mechanicalsHvac",
					"ItemType": "otherAc",
			},
			{
					"CatType": "electrical",
					"ItemType": "unitCapacityAmps",
			},
			{
					"CatType": "electrical",
					"ItemType": "aluminumBranchWiring"
			},
			{
					"CatType": "electrical",
					"ItemType": "edisonBaseTTypeFuses"
			},
			{
					"CatType": "electrical",
					"ItemType": "tamperProofFuses"
			},
			{
					"CatType": "electrical",
					"ItemType": "breakers"
			},
			{
					"CatType": "electrical",
					"ItemType": "gfiOutlets"
			},
			{
					"CatType": "electrical",
					"ItemType": "other",
			},
			{
					"CatType": "interior",
					"ItemType": "drywallWalls"
			},
			{
					"CatType": "interior",
					"ItemType": "plasterWalls"
			},
			{
					"CatType": "interior",
					"ItemType": "woodPaneling"
			},
			{
					"CatType": "interior",
					"ItemType": "carpeting"
			},
			{
					"CatType": "interior",
					"ItemType": "woodFlooring"
			},
			{
					"CatType": "interior",
					"ItemType": "ceramicFloorTile"
			},
			{
					"CatType": "interior",
					"ItemType": "vinylFlooring"
			},
			{
					"CatType": "interior",
					"ItemType": "woodDoors"
			},
			{
					"CatType": "interior",
					"ItemType": "metalDoors"
			},
			{
					"CatType": "interior",
					"ItemType": "sprayTexCeiling"
			},
			{
					"CatType": "interior",
					"ItemType": "smoothCeiling"
			},
			{
					"CatType": "interior",
					"ItemType": "orangePeelTextured"
			},
			{
					"CatType": "interior",
					"ItemType": "other",
			},
			{
					"CatType": "mold",
					"ItemType": "moldEvidenceObserved"
			},
			{
					"CatType": "mold",
					"ItemType": "areasImpactedObserved"
			},
			{
					"CatType": "mold",
					"ItemType": "defectiveBuildingConditionsObserved"
			},
			{
					"CatType": "mold",
					"ItemType": "waterIntrusionsReported"
			},
			{
					"CatType": "mold",
					"ItemType": "tenantComplaintsReported"
			},
			{
					"CatType": "problemMaterialsEquipment",
					"ItemType": "otherA",
			},
			{
					"CatType": "problemMaterialsEquipment",
					"ItemType": "otherB",
			},
			{
					"CatType": "lifeSafetyDevices",
					"ItemType": "smokeDetectors"
			},
			{
					"CatType": "lifeSafetyDevices",
					"ItemType": "carbonMonoxideDetectors"
			},
			{
					"CatType": "lifeSafetyDevices",
					"ItemType": "fireExtinguishers"
			},
			{
					"CatType": "lifeSafetyDevices",
					"ItemType": "emergencyLighting"
			},
			{
					"CatType": "lifeSafetyDevices",
					"ItemType": "emergencyEscapes"
			},
			{
					"CatType": "lifeSafetyDevices",
					"ItemType": "pullStationsCords"
			},
			{
					"CatType": "lifeSafetyDevices",
					"ItemType": "fireAlarm"
			},
			{
					"CatType": "lifeSafetyDevices",
					"ItemType": "sprinklers"
			}
		];
		json.PropertyConditionAssessment[0].PropertyConditionAssessmentBuildingAndMaterials = newAllData.PropertyConditionAssessment[0].PropertyConditionAssessmentBuildingAndMaterials.map((
			item: {
				CatType: string,
				CatSubtype: string,
				ItemType: string,
				OtherItemDescription: string
			}) => {
			return {
				CatType: item.CatType,
				CatSubtype: item.CatSubtype,
				ItemType: item.ItemType,
				OtherItemDescription: item.OtherItemDescription
			};
		});
		json.PropertyConditionAssessment[0].PropertyConditionAssessmentBuildingAndMaterials.sort((a: any, b: any) => {
			const indexA = PropertyConditionAssessmentItemOrder.findIndex(item => 
				item.CatType === a.CatType && 
				(item.CatSubtype === a.CatSubtype || a.CatSubtype === undefined) &&
				item.ItemType === a.ItemType
			);
			const indexB = PropertyConditionAssessmentItemOrder.findIndex(item => 
				item.CatType === b.CatType && 
				(item.CatSubtype === b.CatSubtype || b.CatSubtype === undefined) &&
				item.ItemType === b.ItemType
			);
			return indexA - indexB;
		});

		// sort by CatType
		order = ["sffe", "dwellingUnits", "mechanicalAndElectrical", "site"]
		property = 'CatType';
		json.PropertyConditionAssessment[0].PropertyConditionAssessmentItem = newAllData.PropertyConditionAssessment[0].PropertyConditionAssessmentItem.sort((a: any, b: any) => {
			return order.indexOf(a[property]) - order.indexOf(b[property]);
		});
		// sort object attribute order
		json.PropertyConditionAssessment[0].PropertyConditionAssessmentItem = json.PropertyConditionAssessment[0].PropertyConditionAssessmentItem.map((
			item: {
				ItemType: string,
				CatType: string,
				CatSubtype: string,
				EstUsefulLifeYrCountRangeValue: string,
				RatingType: string,
				RemainingUsefulLifeYrRangeValue: string,
				RepairPriorityType: string,
				CommentText: string,
				ItemCount: number,
				UnitOfMeasureType: string,
				CapitalExpenditurePerUnitOfMeasureCostAmt: number,
				TotalCapitalExpenditureAmt: number,
				AssessmentItemCapitalExpenditureProjectionDetails: {
					PptyItemProjectedYrCapitalExpenditureAmt: number,
					YrNumber: number
				}[]
			}) => {
			return item.TotalCapitalExpenditureAmt === 0 ? {
				ItemType: item.ItemType,
				CatType: item.CatType,
				CatSubtype: item.CatSubtype,
				EstUsefulLifeYrCountRangeValue: item.EstUsefulLifeYrCountRangeValue?item.EstUsefulLifeYrCountRangeValue.toString(): '',
				RemainingUsefulLifeYrRangeValue: item.RemainingUsefulLifeYrRangeValue?item.RemainingUsefulLifeYrRangeValue.toString(): '',
				RepairPriorityType: item.RepairPriorityType,
			} : {
				ItemType: item.ItemType,
				CatType: item.CatType,
				CatSubtype: item.CatSubtype,
				EstUsefulLifeYrCountRangeValue: item.EstUsefulLifeYrCountRangeValue?item.EstUsefulLifeYrCountRangeValue.toString(): '',
				RatingType: item.RatingType,
				RemainingUsefulLifeYrRangeValue: item.RemainingUsefulLifeYrRangeValue?item.RemainingUsefulLifeYrRangeValue.toString(): '',
				RepairPriorityType: item.RepairPriorityType,
				CommentText: item.CommentText,
				ItemCount: item.ItemCount,
				UnitOfMeasureType: item.UnitOfMeasureType,
				CapitalExpenditurePerUnitOfMeasureCostAmt: item.CapitalExpenditurePerUnitOfMeasureCostAmt,
				TotalCapitalExpenditureAmt: item.TotalCapitalExpenditureAmt,
				AssessmentItemCapitalExpenditureProjectionDetails: item.AssessmentItemCapitalExpenditureProjectionDetails
			};
		});

		json.PropertyConditionAssessment[0].PropertyConditionAssessmentWaterTreatment
			= newAllData.PropertyConditionAssessment[0].PropertyConditionAssessmentWaterTreatment;
		json.PropertyConditionAssessment[0].PropertyConditionAssessmentWaterTreatment.forEach(item => {
			if (item.PptyWaterSystemType === "privateWellsDrinkingWater") {
				if (item.WaterSystemMaintenanceResponsiblePartyType === "") {
					item.WaterSystemMaintenanceResponsiblePartyType = "Other";
				} else if (item.WaterSystemMaintenanceResponsiblePartyType === "Professional third-party") {
					item.WaterSystemMaintenancePartyQualificationsDescription = "";
				}
				if (item.WaterSystemMaintenanceResponsiblePartyName === "") {
					delete item.WaterSystemMaintenanceResponsiblePartyName;
				}
				// setting 0 fields
				if (item.WaterSystemMaintenancePartyQualificationsDescription === "") {
					item.WaterSystemMaintenancePartyQualificationsDescription = "0";
				}
			}
		});
		json.PropertyConditionAssessment[0].PropertyConditionAssessmentWaterTreatment.forEach(item => {
			if (item.PptyWaterSystemType === "privateWellsNonDrinkingWater") {
				// setting 0 fields
				if (item.WaterSystemOperationsDescription === "") {
					item.WaterSystemOperationsDescription = "0";
				}
			}
		});
		json.PropertyConditionAssessment[0].PropertyConditionAssessmentWaterTreatment.forEach(item => {
			if (item.PptyWaterSystemType === "wasteWaterTreatment") {
				if (item.WaterSystemMaintenanceResponsiblePartyType === "") {
					item.WaterSystemMaintenanceResponsiblePartyType = "Other";
				} else if (item.WaterSystemMaintenanceResponsiblePartyType === "Professional third-party") {
					item.WaterSystemMaintenancePartyQualificationsDescription = "";
				}
				if (item.WaterSystemMaintenanceResponsiblePartyName === "") {
					delete item.WaterSystemMaintenanceResponsiblePartyName;
				}
				// setting 0 fields
				if (item.WaterSystemOperationsDescription === "") {
					item.WaterSystemOperationsDescription = "0";
				}
				if (item.WastewaterLeachFieldDescription === "") {
					item.WastewaterLeachFieldDescription = "0";
				}
				if (item.WastewaterEffluentDischargeDescription === "") {
					item.WastewaterEffluentDischargeDescription = "0";
				}
				if (item.WaterSystemToMunicipalSystemConnectionDescription === "") {
					item.WaterSystemToMunicipalSystemConnectionDescription = "0";
				}
				if (item.WaterSystemMaintenancePartyQualificationsDescription === "") {
					item.WaterSystemMaintenancePartyQualificationsDescription = "0";
				}
			}
		});
		json.PropertyConditionAssessment[0].PropertyConditionAssessmentWaterTreatment.forEach(item => {
			if (item.PptyWaterSystemType === "privateLiftStations") {
				if (item.WaterSystemMaintenanceResponsiblePartyType === "") {
					item.WaterSystemMaintenanceResponsiblePartyType = "Other";
				} else if (item.WaterSystemMaintenanceResponsiblePartyType === "Professional third-party") {
					item.WaterSystemMaintenancePartyQualificationsDescription = "";
				}
				if (item.WaterSystemMaintenanceResponsiblePartyName === "") {
					delete item.WaterSystemMaintenanceResponsiblePartyName;
				}
				// setting 0 fields
				if (item.WaterSystemOperationsDescription === "") {
					item.WaterSystemOperationsDescription = "0";
				}
				if (item.WaterSystemMaintenancePartyQualificationsDescription === "") {
					item.WaterSystemMaintenancePartyQualificationsDescription = "0";
				}
			}
		});
		if (newAllData.waterCheck[0]) {
			let defaultObjects = [
				{
					"PptyWaterSystemType": "privateWellsDrinkingWater",
					"WaterSystemAsmntItemType": "qualityOfMaintenanceConcerns",
					"WaterSystemViolationInd": "N",
					"WaterSystemViolationDescription": "0"
				},
				{
					"PptyWaterSystemType": "privateWellsDrinkingWater",
					"WaterSystemAsmntItemType": "isEquipmentAccessible",
					"WaterSystemViolationInd": "N",
					"WaterSystemViolationDescription": "0"
				},
				{
					"PptyWaterSystemType": "privateWellsDrinkingWater",
					"WaterSystemAsmntItemType": "backUpWaterSource",
					"WaterSystemViolationInd": "N",
					"WellDrinkingWaterBackupSourceDescription": "0",
					"WaterSystemViolationDescription": "0"
				},
				{
					"PptyWaterSystemType": "privateWellsDrinkingWater",
					"WaterSystemAsmntItemType": "currentOrPreviousViolations",
					"WaterSystemViolationInd": "N",
					"WaterSystemViolationDescription": "0"
				},
				{
					"PptyWaterSystemType": "privateWellsDrinkingWater",
					"WaterSystemAsmntItemType": "atypicalSystemForMarket",
					"WaterSystemViolationInd": "N",
					"WaterSystemViolationDescription": "0"
				},
				{
					"PptyWaterSystemType": "privateWellsDrinkingWater",
					"WaterSystemAsmntItemType": "otherPersonsAuthorized",
					"WaterSystemViolationInd": "N",
					"WaterSystemViolationDescription": "0"
				},
				{
					"PptyWaterSystemType": "privateWellsDrinkingWater",
					"WaterSystemAsmntItemType": "partsOwnedByResidents",
					"WaterSystemViolationInd": "N",
					"WaterSystemViolationDescription": "0"
				},
				{
					"PptyWaterSystemType": "privateWellsDrinkingWater",
					"WaterSystemAsmntItemType": "failureToMeetRequirements",
					"WaterSystemViolationInd": "N",
					"WaterSystemViolationDescription": "0"
				}
			]

			defaultObjects.forEach(defaultObject => {
				if (!json.PropertyConditionAssessment[0].PropertyConditionAssessmentWaterTreatment.some(
					item => item.PptyWaterSystemType === defaultObject.PptyWaterSystemType 
					&& item.WaterSystemAsmntItemType === defaultObject.WaterSystemAsmntItemType)) {
					json.PropertyConditionAssessment[0].PropertyConditionAssessmentWaterTreatment.push(defaultObject);
				}
			});
		}
		if (newAllData.waterCheck[2]) {
			let defaultObjects = [
				{
					"PptyWaterSystemType": "wasteWaterTreatment",
					"WaterSystemAsmntItemType": "qualityOfMaintenanceConcerns",
					"WaterSystemViolationInd": "N",
					"WaterSystemViolationDescription": "0"
				},
				{
					"PptyWaterSystemType": "wasteWaterTreatment",
					"WaterSystemAsmntItemType": "structureOnTopOfLeachField",
					"WaterSystemViolationInd": "N",
					"WaterSystemViolationDescription": "0"
				},
				{
					"PptyWaterSystemType": "wasteWaterTreatment",
					"WaterSystemAsmntItemType": "isEquipmentAccessible",
					"WaterSystemViolationInd": "N",
					"WaterSystemViolationDescription": "0"
				},
				{
					"PptyWaterSystemType": "wasteWaterTreatment",
					"WaterSystemAsmntItemType": "currentOrPreviousViolations",
					"WaterSystemViolationInd": "N",
					"WaterSystemViolationDescription": "0"
				},
				{
					"PptyWaterSystemType": "wasteWaterTreatment",
					"WaterSystemAsmntItemType": "atypicalSystemForMarket",
					"WaterSystemViolationInd": "N",
					"WaterSystemViolationDescription": "0"
				},
				{
					"PptyWaterSystemType": "wasteWaterTreatment",
					"WaterSystemAsmntItemType": "otherPersonsAuthorized",
					"WaterSystemViolationInd": "N",
					"WaterSystemViolationDescription": "0"
				},
				{
					"PptyWaterSystemType": "wasteWaterTreatment",
					"WaterSystemAsmntItemType": "partsOwnedByResidents",
					"WaterSystemViolationInd": "N",
					"WaterSystemViolationDescription": "0"
				},
				{
					"PptyWaterSystemType": "wasteWaterTreatment",
					"WaterSystemAsmntItemType": "failureToMeetRequirements",
					"WaterSystemViolationInd": "N",
					"WaterSystemViolationDescription": "0"
				}
			]
				
			defaultObjects.forEach(defaultObject => {
				if (!json.PropertyConditionAssessment[0].PropertyConditionAssessmentWaterTreatment.some(
					item => item.PptyWaterSystemType === defaultObject.PptyWaterSystemType 
					&& item.WaterSystemAsmntItemType === defaultObject.WaterSystemAsmntItemType)) {
					json.PropertyConditionAssessment[0].PropertyConditionAssessmentWaterTreatment.push(defaultObject);
				}
			});
		}
		if (newAllData.waterCheck[3]) {
			let defaultObjects = [
				{
					"PptyWaterSystemType": "privateLiftStations",
					"WaterSystemAsmntItemType": "qualityOfMaintenanceConcerns",
					"WaterSystemViolationInd": "N",
					"WaterSystemViolationDescription": "0"
				},
				{
					"PptyWaterSystemType": "privateLiftStations",
					"WaterSystemAsmntItemType": "structureOnTopOfLiftStation",
					"WaterSystemViolationInd": "N",
					"WaterSystemViolationDescription": "0"
				},
				{
					"PptyWaterSystemType": "privateLiftStations",
					"WaterSystemAsmntItemType": "isEquipmentAccessible",
					"WaterSystemViolationInd": "N",
					"WaterSystemViolationDescription": "0"
				},
				{
					"PptyWaterSystemType": "privateLiftStations",
					"WaterSystemAsmntItemType": "currentOrPreviousViolations",
					"WaterSystemViolationInd": "N",
					"WaterSystemViolationDescription": "0"
				},
				{
					"PptyWaterSystemType": "privateLiftStations",
					"WaterSystemAsmntItemType": "atypicalSystemForMarket",
					"WaterSystemViolationInd": "N",
					"WaterSystemViolationDescription": "0"
				},
				{
					"PptyWaterSystemType": "privateLiftStations",
					"WaterSystemAsmntItemType": "otherPersonsAuthorized",
					"WaterSystemViolationInd": "N",
					"WaterSystemViolationDescription": "0"
				},
				{
					"PptyWaterSystemType": "privateLiftStations",
					"WaterSystemAsmntItemType": "partsOwnedByResidents",
					"WaterSystemViolationInd": "N",
					"WaterSystemViolationDescription": "0"
				},
				{
					"PptyWaterSystemType": "privateLiftStations",
					"WaterSystemAsmntItemType": "failureToMeetRequirements",
					"WaterSystemViolationInd": "N",
					"WaterSystemViolationDescription": "0"
				}
			]

			defaultObjects.forEach(defaultObject => {
				if (!json.PropertyConditionAssessment[0].PropertyConditionAssessmentWaterTreatment.some(
					item => item.PptyWaterSystemType === defaultObject.PptyWaterSystemType 
					&& item.WaterSystemAsmntItemType === defaultObject.WaterSystemAsmntItemType)) {
					json.PropertyConditionAssessment[0].PropertyConditionAssessmentWaterTreatment.push(defaultObject);
				}
			});
		}
		// sort attribute order
		json.PropertyConditionAssessment[0].PropertyConditionAssessmentWaterTreatment = json.PropertyConditionAssessment[0].PropertyConditionAssessmentWaterTreatment.map((item: {
			PptyWaterSystemType: string,
			PptyWaterSystemSubType: string,
			WaterSystemOperationsDescription: string,
			WastewaterEffluentDischargeDescription: string
			WastewaterLeachFieldDescription: string,
			WaterSystemToMunicipalSystemConnectionDescription: string,
			WaterSystemMaintenanceResponsiblePartyType: string,
			WaterSystemMaintenanceResponsiblePartyName: string,
			WaterSystemMaintenancePartyQualificationsDescription: string,
			WaterSystemAsmntItemType: string,
			WaterSystemViolationInd: string,
			WellDrinkingWaterBackupSourceDescription: string,
			WaterSystemViolationDescription: string,
		}) => {
			return {
				PptyWaterSystemType: item.PptyWaterSystemType,
				PptyWaterSystemSubType: item.PptyWaterSystemSubType,
				WaterSystemOperationsDescription: item.WaterSystemOperationsDescription,
				WastewaterLeachFieldDescription: item.WastewaterLeachFieldDescription,
				WastewaterEffluentDischargeDescription: item.WastewaterEffluentDischargeDescription,
				WaterSystemToMunicipalSystemConnectionDescription: item.WaterSystemToMunicipalSystemConnectionDescription,
				WaterSystemMaintenanceResponsiblePartyType: item.WaterSystemMaintenanceResponsiblePartyType,
				WaterSystemMaintenanceResponsiblePartyName: item.WaterSystemMaintenanceResponsiblePartyName,
				WaterSystemMaintenancePartyQualificationsDescription: item.WaterSystemMaintenancePartyQualificationsDescription,
				WaterSystemAsmntItemType: item.WaterSystemAsmntItemType,
				WaterSystemViolationInd: item.WaterSystemViolationInd,
				WellDrinkingWaterBackupSourceDescription: item.WellDrinkingWaterBackupSourceDescription,
				WaterSystemViolationDescription: item.WaterSystemViolationDescription
			};
		});
		// first sort by PptyWaterSystemType then by WaterSystemAsmntItemType
		// - the order of the following 2 objects should be swapped, however, like with the PropertyConditionAssessmentBuildingAndMaterials,
		// ? this may be easier to fix in the newAllData loading process rather than modifying it here
		// {
		//     "PptyWaterSystemType": "wasteWaterTreatment",
		//     "PptyWaterSystemSubType": "sewageTreatmentPlant"
		// },
		// {
		//     "PptyWaterSystemType": "wasteWaterTreatment",
		//     "PptyWaterSystemSubType": "septicSystem"
		// },
		const orderPptyWaterSystemType = [
			"privateWellsDrinkingWater",
			"privateWellsNonDrinkingWater",
			"wasteWaterTreatment",
			"privateLiftStations"
		];
		const orderWaterSystemAsmntItemType = [
			"qualityOfMaintenanceConcerns",
			"structureOnTopOfLiftStation",
			"structureOnTopOfLeachField",
			"isEquipmentAccessible",
			"backUpWaterSource",
			"currentOrPreviousViolations",
			"atypicalSystemForMarket",
			"otherPersonsAuthorized",
			"partsOwnedByResidents",
			"failureToMeetRequirements"
		];
		json.PropertyConditionAssessment[0].PropertyConditionAssessmentWaterTreatment.sort((a: any, b: any) => {
			const aIndexType = orderPptyWaterSystemType.indexOf(a.PptyWaterSystemType);
			const bIndexType = orderPptyWaterSystemType.indexOf(b.PptyWaterSystemType);

			if (aIndexType !== bIndexType) {
				return aIndexType - bIndexType;
			} else {
				const aIndexItem = orderWaterSystemAsmntItemType.indexOf(a.WaterSystemAsmntItemType);
				const bIndexItem = orderWaterSystemAsmntItemType.indexOf(b.WaterSystemAsmntItemType);
				return aIndexItem - bIndexItem;
			}
		});
		if (newAllData.waterCheck[4] === true || Object.keys(newAllData.waterCheck).slice(0, 4).every(key => newAllData.waterCheck[key] === false)) {
			delete json.PropertyConditionAssessment[0].PropertyConditionAssessmentWaterTreatment;
		}

		json.PropertyConditionAssessment[0].PropertyConditionAssessmentManufacturedHousing = 
		newAllData.PropertyConditionAssessment[0].PropertyConditionAssessmentManufacturedHousing.map((item: any) => {
			if (item.ViolationType === 'lowAmperagePads') {
				delete item.ViolationDescription;
			}
			return item;
		});
		//sort by order of MHC ViolationType
		order = [
			"constructionAndSafetyStandardsConformity",
			"homesNotInZoningCompliance",
			"homesWithUnprofessionalDecksAndPatios",
			"homesWithUnprofessionalSkirting",
			"homesWithExposedHitches",
			"tenantOwnedStructures",
			"tenantOwnedStructures.deficienciesPresent",
			"borrowerOwnedHomesNotMeetingSeismicCodes",
			"propertyInFloodZone",
			"lowAmperagePads",
			"lowAmperagePads.codeFailure",
			"lowAmperagePads.insufficientPower",
			"padsNotReadyForOccupancy",
			"padsWithUnpavedDriveways"
		];
		property = 'ViolationType';
		json.PropertyConditionAssessment[0].PropertyConditionAssessmentManufacturedHousing = 
		json.PropertyConditionAssessment[0].PropertyConditionAssessmentManufacturedHousing.sort((a: any, b: any) => {
			return order.indexOf(a[property]) - order.indexOf(b[property]);
		});
		if (json.PropertyConditionAssessment[0].ManufacturedHousingInd === 'N') {
			delete json.PropertyConditionAssessment[0].PropertyConditionAssessmentManufacturedHousing;
		} else {
			// if the object's indicator is off, the object won't appear in the array
			// so the object must be manually added with the N indicator and default description
			let defaultObjects = [
				// for the first object:
				// adding in a ghost object to match the csv - need to see what the business says
				{
					"ViolationInd": "N",
					"ViolationType": "constructionAndSafetyStandardsConformity",
					"ViolationDescription": "0"
				},
				{
					"ViolationInd": "N",
					"ViolationType": "homesNotInZoningCompliance",
					"ViolationDescription": "0"
				},
				{
					"ViolationInd": "N",
					"ViolationType": "homesWithUnprofessionalDecksAndPatios",
					"ViolationDescription": "0"
				},
				{
					"ViolationInd": "N",
					"ViolationType": "homesWithUnprofessionalSkirting",
					"ViolationDescription": "0"
				},
				{
					"ViolationInd": "N",
					"ViolationType": "homesWithExposedHitches",
					"ViolationDescription": ""
				},
				{
					"ViolationInd": "N",
					"ViolationType": "tenantOwnedStructures",
					"ViolationDescription": "0"
				},
				{
					"ViolationInd": "N",
					"ViolationType": "tenantOwnedStructures.deficienciesPresent",
					"ViolationDescription": "0"
				},
				{
					"ViolationInd": "N",
					"ViolationType": "borrowerOwnedHomesNotMeetingSeismicCodes",
					"ViolationDescription": "0"
				},
				{
					"ViolationInd": "N",
					"ViolationType": "propertyInFloodZone",
					"ViolationDescription": "0"
				},
				{
					"ViolationInd": "N",
					"ViolationType": "lowAmperagePads"
				},
				{
					"ViolationInd": "N",
					"ViolationType": "lowAmperagePads.codeFailure",
					"ViolationDescription": "0"
				},
				{
					"ViolationInd": "N",
					"ViolationType": "lowAmperagePads.insufficientPower",
					"ViolationDescription": "0"
				},
				{
					"ViolationInd": "N",
					"ViolationType": "padsNotReadyForOccupancy",
					"ViolationDescription": "0"
				},
				{
					"ViolationInd": "N",
					"ViolationType": "padsWithUnpavedDriveways",
					"ViolationDescription": "0",
					"UnpavedDrivewayPadSiteWithCurrentlyOccupiedHomeInd": "N",
					"UnpavedDrivewayPadSiteWithCurrentlyOccupiedHomeCount": 0,
					"UnpavedDrivewayPadSiteWithVacantDownOfflineHomeInd": "N",
					"UnpavedDrivewayPadSiteWithVacantHomeCount": 0,
					"UnpavedDrivewayPadSiteNeverHadHomeCount": 0,
					"UnpavedDrivewayPadSiteWithPastNotPresentHomeCount": 0,
					"UnpavedDrivewayPadSiteTotalPavingCostAmt": 0
				}
			];

			defaultObjects.reverse().forEach(defaultObject => {
				let exists = json.PropertyConditionAssessment[0].PropertyConditionAssessmentManufacturedHousing.some(item => item.ViolationType === defaultObject.ViolationType);
			
				if (!exists) {
					json.PropertyConditionAssessment[0].PropertyConditionAssessmentManufacturedHousing.unshift(defaultObject);
				}
			});
		}

		/// remove items where the estimated cost amount is 0
		json.PropertyConditionAssessment[0].PropertyRepair = newAllData.PropertyConditionAssessment[0].PropertyRepair.filter((item: any) => item.EstCostAmt !== 0);
		// move objects with only PriorityType and CommentText as their attributes to the end
		json.PropertyConditionAssessment[0].PropertyRepair.sort((a: any, b: any) => {
			const aKeys = Object.keys(a);
			const bKeys = Object.keys(b);

			if (aKeys.length === 2 && aKeys.includes('PriorityType') && aKeys.includes('CommentText')) {
				return 1;
			} else if (bKeys.length === 2 && bKeys.includes('PriorityType') && bKeys.includes('CommentText')) {
				return -1;
			} else {
				return 0;
			}
		});
		if (json.PropertyConditionAssessment[0].PropertyRepair.length === 0) {
			delete json.PropertyConditionAssessment[0].PropertyRepair;
		}

		// fixed "BuildingsLocatedNearFaultOrSpecialStudyZoneInd": ""
		json.PropertyConditionAssessment[0].PropertySeismicRiskAssessment = newAllData.PropertyConditionAssessment[0].PropertySeismicRiskAssessment.map((item: any) => {
			const newItem = { ...item };
			Object.keys(newItem).forEach(key => {
				if (newItem[key] === 'N' && key !== 'SeismicRiskFactorInd') {
					delete newItem[key];
				}
				if (newItem[key] === '') {
					delete newItem[key];
				}
			});
			return newItem;
		});
		json.PropertyConditionAssessment[0].PropertySeismicRiskAssessment = json.PropertyConditionAssessment[0].PropertySeismicRiskAssessment.map((item: {
			SeismicRiskFactorInd: string,
			BuildingsWithWeakOrSoftFloorsInd: string,
			BuildingsWithDirectContactToAdjacentBuildingsInd: string,
			BuildingsWithPrevEarthquakeDamageInd: string,
			BuildingsHighRiseInd: string,
			BuildingsWithReinforcedConcreteBuiltPriorTo1994Indictor: string,
			BuildingsWithReinforcedConcreteLoadBearingWallsBuiltPriorTo1994Ind: string,
			BuildingsWithUnreinforcedMasonryRetrofittedInd: string,
			BuildingsWithUnreinforcedMasonryRetrofittedPriorTo1995Indictor: string,
			BuildingsWithWoodFrameConspicuousDeteriorationInd: string,
			WoodFrameBuiltPriorTo1950Ind: string,
			BuildingsWithWoodFrameParkingUnderUnitsNonRetrofittedAndBuiltPriorTo2000Ind: string,
			BuildingsWithLightFrameOverConcretePodiumBuiltPriorTo1994Ind: string,
			BuildingsLocatedNearFaultOrSpecialStudyZoneInd: string
		}) => {
		return {
			SeismicRiskFactorInd: item.SeismicRiskFactorInd,
			BuildingsWithWeakOrSoftFloorsInd: item.BuildingsWithWeakOrSoftFloorsInd,
			BuildingsWithDirectContactToAdjacentBuildingsInd: item.BuildingsWithDirectContactToAdjacentBuildingsInd,
			BuildingsWithPrevEarthquakeDamageInd: item.BuildingsWithPrevEarthquakeDamageInd,
			BuildingsHighRiseInd: item.BuildingsHighRiseInd,
			BuildingsWithReinforcedConcreteBuiltPriorTo1994Indictor: item.BuildingsWithReinforcedConcreteBuiltPriorTo1994Indictor,
			BuildingsWithReinforcedConcreteLoadBearingWallsBuiltPriorTo1994Ind: item.BuildingsWithReinforcedConcreteLoadBearingWallsBuiltPriorTo1994Ind,
			BuildingsWithUnreinforcedMasonryRetrofittedInd: item.BuildingsWithUnreinforcedMasonryRetrofittedInd,
			BuildingsWithUnreinforcedMasonryRetrofittedPriorTo1995Indictor: item.BuildingsWithUnreinforcedMasonryRetrofittedPriorTo1995Indictor,
			BuildingsWithWoodFrameConspicuousDeteriorationInd: item.BuildingsWithWoodFrameConspicuousDeteriorationInd,
			WoodFrameBuiltPriorTo1950Ind: item.WoodFrameBuiltPriorTo1950Ind,
			BuildingsWithWoodFrameParkingUnderUnitsNonRetrofittedAndBuiltPriorTo2000Ind: item.BuildingsWithWoodFrameParkingUnderUnitsNonRetrofittedAndBuiltPriorTo2000Ind,
			BuildingsWithLightFrameOverConcretePodiumBuiltPriorTo1994Ind: item.BuildingsWithLightFrameOverConcretePodiumBuiltPriorTo1994Ind,
			BuildingsLocatedNearFaultOrSpecialStudyZoneInd: item.BuildingsLocatedNearFaultOrSpecialStudyZoneInd
		};
		});

		// fill in custom order
		json.PropertyTotalRentRollSummary = [{}];
		json.PropertyTotalRentRollSummary[0].PptyTotalOtherMgmtOfficeUnitCount = newAllData.PropertyTotalRentRollSummary[0].PptyTotalOtherMgmtOfficeUnitCount;
		json.PropertyTotalRentRollSummary[0].PptyTotalOtherModelUnitCount = newAllData.PropertyTotalRentRollSummary[0].PptyTotalOtherModelUnitCount;
		json.PropertyTotalRentRollSummary[0].PptyTotalOtherMaintenanceShopUnitCount = newAllData.PropertyTotalRentRollSummary[0].PptyTotalOtherMaintenanceShopUnitCount;
		json.PropertyTotalRentRollSummary[0].PptyTotalOtherStorageUnitCount = newAllData.PropertyTotalRentRollSummary[0].PptyTotalOtherStorageUnitCount;
		json.PropertyTotalRentRollSummary[0].PptyTotalOtherHospitalitySuiteUnitCount = newAllData.PropertyTotalRentRollSummary[0].PptyTotalOtherHospitalitySuiteUnitCount;
		json.PropertyTotalRentRollSummary[0].PptyTotalOtherMiscellaneousUnitCount = newAllData.PropertyTotalRentRollSummary[0].PptyTotalOtherMiscellaneousUnitCount;
		json.PropertyTotalRentRollSummary[0].TotalOtherUnitCount = newAllData.PropertyTotalRentRollSummary[0].TotalOtherUnitCount;
		json.PropertyTotalRentRollSummary[0].PptyTotalDownUnitCount = newAllData.PropertyTotalRentRollSummary[0].PptyTotalDownUnitCount;
		json.PropertyTotalRentRollSummary[0].TotalOccupiedUnitCount = newAllData.PropertyTotalRentRollSummary[0].TotalOccupiedUnitCount;
		json.PropertyTotalRentRollSummary[0].TotalVacantUnitCount = newAllData.PropertyTotalRentRollSummary[0].TotalVacantUnitCount;
		json.PropertyTotalRentRollSummary[0].TotalUnitCount = newAllData.PropertyTotalRentRollSummary[0].TotalUnitCount;
		json.PropertyTotalRentRollSummary[0].PropertyCommercialRentRollSummary = newAllData.PropertyTotalRentRollSummary[0].PropertyCommercialRentRollSummary;
		json.PropertyTotalRentRollSummary[0].PropertyResidentialRentRollSummary = newAllData.PropertyTotalRentRollSummary[0].PropertyResidentialRentRollSummary;
		json.PropertyTotalRentRollSummary[0].PropertyCommercialUsageMix = newAllData.PropertyTotalRentRollSummary[0].PropertyCommercialUsageMix;

		json.PropertyTotalRentRollSummary[0].PropertyResidentialUnitMix = newAllData.PropertyTotalRentRollSummary[0].PropertyResidentialUnitMix;
		json.PropertyTotalRentRollSummary[0].PropertyResidentialUnitMix = json.PropertyTotalRentRollSummary[0].PropertyResidentialUnitMix.map((
			item: {
				BedroomCount: number,
				BathroomCount: number,
				AvgSquareFeetNumber: number,
				StyleType: string,
				PptyUnitTypeOccupiedUnitCount: number,
				VacantUnitCount: number,
				PptyUnitTypeDownUnitCount: number,
				PptyUnitTypeOtherUnitCount: number,
				PptyUnitTypeOccupiedInspectedUnitCount: number,
				PptyUnitTypeVacantInspectedUnitCount: number,
				PptyUnitTypeDownInspectedUnitCount: number,
				PptyUnitTypeOtherInspectedUnitCount: number
			}) => {
			return {
				BedroomCount: item.BedroomCount,
				BathroomCount: item.BathroomCount,
				AvgSquareFeetNumber: item.AvgSquareFeetNumber,
				StyleType: item.StyleType,
				PptyUnitTypeOccupiedUnitCount: item.PptyUnitTypeOccupiedUnitCount,
				VacantUnitCount: item.VacantUnitCount,
				PptyUnitTypeDownUnitCount: item.PptyUnitTypeDownUnitCount,
				PptyUnitTypeOtherUnitCount: item.PptyUnitTypeOtherUnitCount,
				PptyUnitTypeOccupiedInspectedUnitCount: item.PptyUnitTypeOccupiedInspectedUnitCount,
				PptyUnitTypeVacantInspectedUnitCount: item.PptyUnitTypeVacantInspectedUnitCount,
				PptyUnitTypeDownInspectedUnitCount: item.PptyUnitTypeDownInspectedUnitCount,
				PptyUnitTypeOtherInspectedUnitCount: item.PptyUnitTypeOtherInspectedUnitCount
			};
		});

		json.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit = newAllData.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit;
		json.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit = json.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit.filter(item => item !== null);
		json.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit = json.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit.filter(item => {
			let values = Object.values(item);
			return !values.every(value => value === "");
		});

		// let jdata = JSON.stringify(json);
		// let mhc = JSON.stringify(json.PropertyConditionAssessment[0].PropertyConditionAssessmentManufacturedHousing);
		// let pwd = JSON.stringify(json.PropertyConditionAssessment[0].PropertyConditionAssessmentWaterTreatment);

		return json;

	}
		processSignatureTemplate(htmlSec: any): any {
		if (!htmlSec || !htmlSec.changingThisBreaksApplicationSecurity) {
			return htmlSec;
		}
		let htmlString = htmlSec.changingThisBreaksApplicationSecurity;

		htmlString = htmlString.replace(/margin-bottom:\s*-10px/g, `margin-bottom: -3px`);
		return {
			...htmlSec,
			changingThisBreaksApplicationSecurity: htmlString
		};
	}
	
	adjustColWidth(){
		let ids=['fme_exec_sum_ir_1', 'fme_exec_sum_ir_2', 'fme_exec_sum_ir_3', 'fme_exec_sum_ir_4','fme_exec_sum_ir_5'];
		let tables = [];
		for(let sec of this.contents){
			if(sec.id == "4099eEstimate"){
				for(let sec1 of sec.SUB_SECTIONS){
					if(sec1.id == "fme_exec_sum_ir"){
						for(let sec2 of sec1.SUB_SECTIONS){
							if(ids.includes(sec2.id)){
								tables.push(sec2);
							}
						}
						break;
					}					
				}
			}
		}
		let summaryTotalCost="";
		if(tables[3].data.rows[0][2] && tables[3].data.rows[0][2].data > 0){
			summaryTotalCost = this.USDollar.format(tables[3].data.rows[0][2].data);
		}
		let summaryTable=tables.slice(0, 3);		
		this.applyCustomTableWidthRules(summaryTable, summaryTotalCost);		
	}
	applyCustomTableWidthRules(tables: any[], summaryTotalCost: string) {
		let iniWidths = [10, 10, 10, 10, 10, 20, 10];
		let percents=[10, 10, 10, 10, 10, 20, 10];
		let maxBdLength = 0;
		tables=JSON.parse(JSON.stringify(tables));
		tables.forEach((doc: any, tableIndex: number) => {
			if (!doc.data || !doc.data.cols || !doc.data.rows) return;

			// 1. Find the maximum character length for "Brief Description" (Key: "BD" or col5)
			
			doc.data.rows.forEach((row: any[]) => {
			row.forEach((cell: any) => {
				if (cell.KEY === 'BD' || cell.COLUMNINTERNALNAME === 'col5') {
				const textLen = String(cell.data || '').length;
				if (textLen > maxBdLength) {
					maxBdLength = textLen;
				}
				}
			});
			});
			doc.data.cols.forEach((col: any, colIndex: number) => {
			if (colIndex === 5) return; // Skip brief description for now

			let longestWordLen = tables[0].data.cols[colIndex].NAME.split(/\s+/).reduce((max, w) => Math.max(max, w.length), 0);
			doc.data.rows.forEach((row: any[]) => {
				if(!(colIndex ==0 &&row[colIndex].colspan)){// Skip rows that are merged across columns
					const cell = row[colIndex];
					if (cell && !cell.colspan) {
						let valStr = String(cell.data || '');
						if (cell.sign) valStr = this.USDollar.format(cell.data) || '';//`$ ${valStr}`;
						const longestInCell = (valStr.split(/\s+/).reduce((max, w) => Math.max(max, w.length), 0));
						if (longestInCell > longestWordLen) {
							longestWordLen = longestInCell;
						}
						if(longestWordLen > iniWidths[colIndex]){
							iniWidths[colIndex] = longestWordLen; //console.log("longestWordLen", longestWordLen);
						}						
					}
				}else{
					//console.log("row[colIndex]", row[colIndex]);
				}
			});			
			});
		});
			//iniWidths[6] = 9;
			
			iniWidths[0]=iniWidths[0]+2; // add 2 to the "Priority" column for spacing
			iniWidths[3]=iniWidths[3]+2;
			if((summaryTotalCost.length+2)>iniWidths[4]){
				iniWidths[4] = summaryTotalCost.length+2;
			}
			const sumOriWidths = iniWidths.reduce((acc, val) => acc + val, 0)-iniWidths[5];
			let finalbdWidth = 20; // default for < 50 chars
			if (maxBdLength > 80) {
			finalbdWidth = 50;
			} else if (maxBdLength > 30) {
			finalbdWidth = 30;
			}
			iniWidths[5] = finalbdWidth;
			//iniWidths[3] = iniWidths[3] + 1; // add 4 to the "Other" column for spacing
			iniWidths.forEach((w, i) => {
				let percent = Math.ceil((w / sumOriWidths) * ( 100-iniWidths[5] ));
				percents[i] = percent;
			});
			//percents[5] = finalbdWidth; console.log("percents", percents);
			//percents[0]=100-percents[1]-percents[2]-percents[3]-percents[4]-percents[5]-percents[6];	console.log("percents", percents);	
			percents[5]=100-percents[1]-percents[2]-percents[3]-percents[4]-percents[0]-percents[6];	//console.log("percents", percents);	
			this.applyCustomTableWidthRules2(percents);			
		}
		applyCustomTableWidthRules2(percents: number[]) {
			let ids=['fme_exec_sum_ir_1', 'fme_exec_sum_ir_2', 'fme_exec_sum_ir_3', 'fme_exec_sum_ir_4','fme_exec_sum_ir_5'];
			for(let sec of this.contents){
				if(sec.id == "4099eEstimate"){
					for(let sec1 of sec.SUB_SECTIONS){
						if(sec1.id == "fme_exec_sum_ir"){
							for(let sec2 of sec1.SUB_SECTIONS){
								let index=ids.indexOf(sec2.id);
								if(index<3){
									sec2.data.cols.forEach((col: any, subindex: number) => {
										col.width = percents[subindex] || 10;
									})
									
								}else if(index==3){
									sec2.data.cols.forEach((col: any, subindex: number) => {
										if(subindex==0){
											col.width = (percents[0]+percents[1]+percents[2]) || 41;
										}else{
											col.width = percents[subindex+2] || 10;
										}	
									})
									sec2.data.rows[0].forEach((row: any, subindex: number) => {
										if(subindex==0){
											row.width = (percents[0]+percents[1]+percents[2]) || 41;
										}else{
											row.width = percents[subindex+2] || 10;
										}	
									})
								}else if(index==4){
									sec2.data.cols.forEach((col: any, subindex: number) => {
										if(subindex==0){
											col.width = percents[0] || 10;
										}else if(subindex==1){
											col.width = (percents[1]+percents[2]+percents[3]+percents[4]+percents[5] ) || 10;
										}else{
											col.width = percents[6] || 10;
										}											
									})								
								}								
							}
							//console.log(sec1);
							break;
						}					
					}
				}
			}
			
		}		
}
